import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, OverlayTrigger, Tooltip, Modal, Table} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import { formatarValor, 
         validaSenha, 
         hasPerm, 
         tiposAcesso, 
         getCurrentUser, 
         formatarValorAPI, 
         formatarValorLocal, 
         isValidUrl, 
         formataDataHoraExibicao,
         estados } from '../../common/utils';
import { IMaskInput } from "react-imask";
import AsyncSelect from 'react-select/async';
import { NumericFormat } from 'react-number-format';
import Select from 'react-select';
import axios from 'axios';
import { FaCheck, FaTimes, FaStream, FaEye, FaEyeSlash, FaSync, FaSearch, FaEraser, FaPlus } from "react-icons/fa";
import { pdfjs } from 'react-pdf';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import Paginacao from "../../common/pagination";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
let buscaCepTimer = null;

class PrestadoresEdit extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);
        this.onChangeCep = this.onChangeCep.bind(this);
        this.onChangeGrupo = this.onChangeGrupo.bind(this);
        this.onChangeArquivo = this.onChangeArquivo.bind(this);
        this.handleProgramaChange = this.handleProgramaChange.bind(this);

        this.onChangeImagem = this.onChangeImagem.bind(this);

        this.fileInputAlvara = React.createRef();
        this.fileInputContrato = React.createRef();
        this.fileInputCNPJ = React.createRef();
        this.fileInputCertidao = React.createRef();
        this.pdfWrapperRef = React.createRef();
        

        this.list_tipos_pessoa = {
            "fisica": "Física", 
            "juridica": "Jurídica"
        };

        this.list_tipos_faturamento = {
            "matriz": "Matriz", 
            "filial": "Filial"
        };

        this.list_categorias = {
            "medicos": "Médicos",
            "multiprofissionais": "Multiprofissionais",
            "farmacias": "Farmácias",
            "hospitais": "Hospitais",
            "clinicas": "Clínicas",
            "plataformas": "Plataformas",
            "laboratorio_diagnostico": "Laboratórios de Diagnósticos",
            "cooperativas_saude": "Cooperativas de Saúde",
            "motoristas": "Transporte",
            "logistica": "Logística"
        };
        
        this.list_generos = {
            "F": "Feminino",
            "M": "Masculino",
            "O": "Outro",
        };

        this.ufOptions = estados;

        this.state = {
            nome: '',
            cpf: '',
            cnpj: '',
            email: "",
            email_2: "",
            email_3: "",
            mostrarEmail2: false,
            mostrarEmail3: false,
            razao_social: "",
            nome_fantasia: "",
            tipo_pessoa: "fisica",
            telefone: "",
            telefone_2: "",
            telefone_3: "",
            mostrarTelefone2: false,
            mostrarTelefone3: false,
            telefoneHelper: '',
            telefone_2Helper: '',
            telefone_3Helper: '',
            celular: "",
            celular_2: "",
            celular_3: "",
            mostrarCelular2: false,
            mostrarCelular3: false,
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            cep: '',
            uf: '',
            estados_atendimento: [],
            cidade: '',
            genero: '',
            registro: '',
            registro_uf: '',
            categoria: '',
            contato_nome: '',
            contato_email: '',
            contato_celular: '',
            mentor: false,
            imagem_upload: '',
            logomarca_pdf_termo: '',
            tipo_faturamento: '',
            imagemHelper: "",
            nomeHelper: "",
            cpfHelper: "",
            cnpjHelper: "",
            emailHelper: "",
            razaoSocialHelper: "",
            nomeFantasiaHelper: "",
            tipoPessoaHelper: "",
            celularHelper: "",
            enderecoHelper: "",
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cepHelper: '',
            ufHelper: '',
            cidadeHelper: '',
            generoHelper: '',
            registroHelper: '',
            registroUfHelper: '',
            categoriaHelper: '',
            tipoEmpresaHelper: '',
            contatoNomeHelper: '',
            contatoEmailHelper: '',
            contatoCelularHelper: '',
            tipoFaturamentoHelper: '',
            titulo_pagina: "",
            loading: false,
            erroLoadRegistro: '',
            prestador_id: '',
            grupo_id: '',
            grupo_nome: '',
            cliente_id: '',
            cliente_nome: '',
            especialidade_id: '', 
            especialidade_nome: '',
            categoria_multiprofissional_id: '',
            categoria_multiprofissional_nome: '',
            especialidade_multiprofissional_id: '',
            especialidade_multiprofissional_nome: '',
            programa_uuid: '',
            programa_nome: '',
            termo_prestador_id: '',
            termo_prestador_nome: '',
            assinatura_letssign: '',
            alerta_atendimento: '',

            //Documentos
            alvara: '',
            alvara_cadastrado: '',
            tipo_alvara: '',
            data_vencimento_alvara: '',
            contrato_social: '',
            cartao_cnpj: '',
            certidao_regularidade: '',
            status_contrato: '',
            treinamento: '',

            uploadPreview: null,       
            uploadFile: null,          
            nomeCampoUpload: '',       
            showModalConfirmacao: false,

            especialidades: [],
            clientes: [],
            laboratorios: [],
            programas: [],
            senha: '',
            senha_confirma: '',
            mostrarSenha: { senha: false, senhaConfirma: false, password: false, password_confirm: false },
            requisitosSenha: {
                tamanho: false,
                minuscula: false,
                maiuscula: false,
                numero: false,
                especial: false
            },
            permite_editar: true,
            acesso_unico: false,
            cadastro_teste: false,
            servicos: [],
            servicosData: {},
            page_servicos: 1,
            loadingServicos: false,
            filtro_servico_id: '',
            filtro_servico_nome: '',
            servicosDisponiveis: [],
            showModalServico: false,
            servicoAtual: {
                id: '',
                servico_id: '',
                servico_nome: '',
                valor: '',
                valor_parceiros: '',
                valor_compra: '',
                ativo: true
            },
            showModalUsuario: false,
            usuarioAtual: {
                id: '',
                email: '',
                username: '',
                is_active: true,
                first_name: '',
                last_name: '',
                password: '',
                password_confirm: '',
                grupo_id: ''
            },
            usuarioErrors: {},
            loadingServicos: false,
            replicarParaFiliais: false,
            matriz_id: '',
            matriz_nome: '',
            tipo_empresa: 'matriz',
            numPages: null,
            pageWidth: 0,
            tipo_prestador : 'credenciado',
            is_active: true,
            visualizar_agendamentos_filiais: 'false',
            usuarios: [],
        };
    }

    componentDidMount(){
        let dados_usuario = getCurrentUser();
        this.carregarDadosPrestadores();
        this.consultaServicos(1);

        //Ajusta tamanho pdf
        this.updatePageWidth();
        window.addEventListener('resize', this.updatePageWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updatePageWidth);
    }

    updatePageWidth = () => {
        const wrapper = this.pdfWrapperRef.current;
        if (wrapper) {
        this.setState({ pageWidth: wrapper.offsetWidth });
        }
    };

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    };

    carregarDadosPrestadores = () => {
        const id = this.props.router.params.id;
    
        if (id) {
            this.setState({
                prestador_id: id,
                loading: true,
                erroLoadRegistro: '',
            });
    
            // Consulta os dados do prestador na API
            api.get(`/pessoas/prestadores/${id}`)
                .then(response => {
                    // Tratando dados recebidos para garantir que não tenham valores nulos ou "null"
                    const dados = response.data;
                    const dadosPessoa = this.tratarNulos(dados);
    
                    // Preenche os inputs com os dados tratados
                    this.setState({
                        erroLoadRegistro: '',
                        nome: dadosPessoa.nome,
                        cpf: dadosPessoa.tipo_pessoa === 'fisica' ? dadosPessoa.cpf_cnpj : '',
                        cnpj: dadosPessoa.tipo_pessoa === 'juridica' ? dadosPessoa.cpf_cnpj : '',
                        email: dadosPessoa.email,
                        email_2: dadosPessoa.email_2,
                        email_3: dadosPessoa.email_3,
                        mostrarEmail2: dadosPessoa.email_2 ? true : false,
                        mostrarEmail3: dadosPessoa.email_3 ? true : false,
                        razao_social: dadosPessoa.razao_social,
                        nome_fantasia: dadosPessoa.nome_fantasia,
                        tipo_pessoa: dadosPessoa.tipo_pessoa,
                        telefone: dadosPessoa.telefone,
                        telefone_2: dadosPessoa.telefone_2,
                        telefone_3: dadosPessoa.telefone_3,
                        mostrarTelefone2: dadosPessoa.telefone_2 ? true : false,
                        mostrarTelefone3: dadosPessoa.telefone_3 ? true : false,
                        celular: dadosPessoa.celular,
                        celular_2: dadosPessoa.celular_2,
                        celular_3: dadosPessoa.celular_3,
                        mostrarCelular2: dadosPessoa.celular_2 ? true : false,
                        mostrarCelular3: dadosPessoa.celular_3 ? true : false,
                        endereco: dadosPessoa.endereco,
                        numero: dadosPessoa.numero,
                        complemento: dadosPessoa.complemento,
                        bairro: dadosPessoa.bairro,
                        cep: dadosPessoa.cep,
                        uf: dadosPessoa.uf,
                        estados_atendimento: dadosPessoa.estados_atendimento ? dadosPessoa.estados_atendimento.map(sigla => ({
                             value: sigla,
                             label: this.ufOptions[sigla] || sigla
                        })) : [],
                        cidade: dadosPessoa.cidade,
                        genero: dadosPessoa.genero,
                        mentor: dadosPessoa.mentor,
                        cadastro_teste: dadosPessoa.cadastro_teste,
                        registro: dadosPessoa.registro,
                        registro_uf: dadosPessoa.registro_uf,
                        categoria: dadosPessoa.categoria,
                        tipo_empresa: dadosPessoa.tipo_empresa,
                        contato_nome: dadosPessoa.contato_nome,
                        contato_email: dadosPessoa.contato_email,
                        contato_celular: dadosPessoa.contato_celular,
                        logomarca_pdf_termo: dadosPessoa.logomarca_pdf_termo,
                        cliente_id: dadosPessoa.cliente_id,
                        cliente_nome: dadosPessoa.dados_cliente.nome,
                        especialidade_id: dadosPessoa.especialidade_id,
                        categoria_multiprofissional_id: dadosPessoa.categoria_multiprofissional_id,
                        programa_uuid: dadosPessoa.dados_programa.uuid,
                        programa_nome: dadosPessoa.dados_programa.nome,
                        termo_prestador_id: dadosPessoa.termo_prestador_id,
                        termo_prestador_nome: dadosPessoa.dados_termo_prestador.nome,
                        assinatura_letssign: dadosPessoa.assinatura_letssign,
                        alerta_atendimento: dadosPessoa.alerta_atendimento,
                        acesso_unico: dados.acesso_unico,
                        loading: false,
                        titulo_pagina: 'Editando Provedor: ' + dadosPessoa.nome,
                        matriz_id: dadosPessoa.matriz_id,
                        matriz_nome: dadosPessoa.dados_matriz.razao_social,
                        tipo_faturamento: dadosPessoa.tipo_faturamento,
                        filiais: dadosPessoa.dados_filiais,
                        //Documentos
                        alvara: dadosPessoa.alvara,
                        alvara_cadastrado: dadosPessoa.alvara,
                        tipo_alvara: dadosPessoa.tipo_alvara,
                        data_vencimento_alvara: dadosPessoa.data_vencimento_alvara,
                        contrato_social: dadosPessoa.contrato_social,
                        cartao_cnpj: dadosPessoa.cartao_cnpj,
                        certidao_regularidade: dadosPessoa.certidao_regularidade,
                        status_contrato: dadosPessoa.status_contrato,
                        treinamento: dadosPessoa.treinamento,
                        tipo_prestador: dadosPessoa.tipo_prestador,
                        is_active: dadosPessoa.is_active,
                        visualizar_agendamentos_filiais: dadosPessoa.visualizar_agendamentos_filiais,
                    }, () => {
                    });
    
                    this.carregarProgramasPrestador();
                    this.carregarLaboratoriosMedico();

                    // Carregar serviços do prestador se estiver editando
                    if (this.state.prestador_id) {
                        this.carregarServicosPrestador();
                        this.carregarUsuariosPrestador();
                    }

                })
                .catch(error => {
                    let erro_msg = 'Erro ao consultar provedor, tente novamente';
    
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                    });
                });
        } else {
            if (!hasPerm('add_prestadores')) {
                window.location.href = '/sem-permissao';
                return;
            }
    
            this.setState({
                prestador_id: '',
                titulo_pagina: 'Adicionar Provedor',
                loading: false,
                erroLoadRegistro: '',
            });
        }
    };
    

    verificaBloqueioEdicao = () => {
        const tipos_acesso = tiposAcesso();

        if ('gestor' in tipos_acesso) {
            if ('tipo_gestor' in tipos_acesso.gestor && tipos_acesso.gestor.tipo_gestor == 'industria') {
                this.setState({ permite_editar: false });            
            }            
        }
    }

    verificaRequisitosSenha = (senha) => {
        const requisitos = {
            tamanho: senha.length > 8,
            minuscula: /[a-z]/.test(senha),
            maiuscula: /[A-Z]/.test(senha),
            numero: /[0-9]/.test(senha),
            especial: /[$@#&!]/.test(senha)
        };
        this.setState({ requisitosSenha: requisitos });
    }

    tratarNulos = (obj) => {
        const novoObjeto = {};
        for (let key in obj) {
            novoObjeto[key] = (obj[key] === null || obj[key] === "null") ? "" : obj[key];
        }
        return novoObjeto;
    };
    


    enviaRegistro = (e) => {
        e.preventDefault();
        let dados_usuario = getCurrentUser();

        if (this.state.tipo_alvara) {
            const temAlvaraNovo = this.state.alvara instanceof File;
            if (!temAlvaraNovo && !this.state.alvara_cadastrado) {
                Swal.fire({
                    icon: 'error',
                    title: 'Alvará obrigatório',
                    text: 'Por favor, anexe o arquivo do Alvará.',
                });
                return;
            }
        }

        if (this.state.tipo_alvara === 'alvara') {
            // 1) data de vencimento
            const hoje = new Date();
            const venc = this.state.data_vencimento_alvara
                ? new Date(this.state.data_vencimento_alvara)
                : null;

            if (!venc) {
                Swal.fire({
                    icon: 'error',
                    title: 'Data de vencimento do alvará é obrigatória',
                    text: 'Por favor, informe a data de vencimento do alvará.',
                });
                return;
            }
            if (venc < new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate())) {
                Swal.fire({
                    icon: 'error',
                    title: 'Data inválida',
                    text: 'A data de vencimento não pode ser anterior a hoje.',
                });
                return;
            }
        }
        
        if (this.state.senha) {
            if (!validaSenha(this.state.senha)) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Sua senha deve ter mais de 8 caracteres, incluir pelo menos uma letra maiúscula, uma letra minúscula, um número e um caractere especial.',
                    showCloseButton: true,
                });
                return;
            }
    
            if (this.state.senha !== this.state.senha_confirma) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'As senhas não coincidem.',
                    showCloseButton: true,
                });
                return; // Para interromper a execução se houver erro
            }
        }

        const camposTelefone = ['telefone', 'telefone_2', 'telefone_3'];
        const camposCelular = ['celular', 'celular_2', 'celular_3'];

        for (let campo of camposTelefone) {
            const valor = this.state[campo];
            if (valor) {
                const apenasNumeros = valor.replace(/\D/g, '');
                if (apenasNumeros.length < 10) {
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'error',
                        title: 'Telefone inválido',
                        text: `O Campo ${campo.replace('_', ' ')} deve conter ao menos 10 dígitos.`,
                        showCloseButton: true
                    });
                    return;
                }
            }
        }

        for (let campo of camposCelular) {
            const valor = this.state[campo];
            if (valor) {
                const apenasNumeros = valor.replace(/\D/g, '');
                if (apenasNumeros.length < 11) {
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'error',
                        title: 'Celular inválido',
                        text: `O Campo ${campo.replace('_', ' ')} deve conter ao menos 11 dígitos.`,
                        showCloseButton: true
                    });
                    return;
                }
            }
        }
    
        // Verifica se é edição ou adição
        const url = this.state.prestador_id ? '/pessoas/prestadores/' + this.state.prestador_id + '/' : '/pessoas/prestadores/';
        const metodo = this.state.prestador_id ? 'put' : 'post';
    
        // Prepara os dados para o envio
        const formData = new FormData();

        const cliente_id = dados_usuario['ambiente_cliente_id'] || this.state.cliente_id;
        const programa_uuid = dados_usuario['ambiente_programa_uuid'] || this.state.programa_uuid;

        const dadosTratados = {
            nome: this.state.tipo_pessoa === 'fisica' ? this.state.nome : this.state.razao_social,
            email: this.state.email,
            email_2: this.state.email_2 || '',
            email_3: this.state.email_3 || '',
            razao_social: this.state.razao_social,
            nome_fantasia: this.state.nome_fantasia,
            tipo_pessoa: this.state.tipo_pessoa,
            telefone: this.state.telefone,
            telefone_2: this.state.telefone_2 || '',
            telefone_3: this.state.telefone_3 || '',
            celular: this.state.celular,
            celular_2: this.state.celular_2 || '',
            celular_3: this.state.celular_3 || '',
            endereco: this.state.endereco,
            numero: this.state.numero,
            complemento: this.state.complemento,
            bairro: this.state.bairro,
            cep: this.state.cep,
            uf: this.state.uf,
            cidade: this.state.cidade,
            categoria: this.state.categoria,
            tipo_empresa: this.state.tipo_empresa,
            mentor: this.state.mentor,
            cadastro_teste: this.state.cadastro_teste,
            contato_nome: this.state.contato_nome,
            contato_email: this.state.contato_email,
            contato_celular: this.state.contato_celular,
            genero: this.state.tipo_pessoa === 'fisica' ? this.state.genero : '',
            senha: this.state.senha && this.state.grupo_id ? this.state.senha : '',
            grupo_id: this.state.grupo_id || '',
            especialidade_id: this.state.especialidade_id,
            especialidade_multiprofissional_id: this.state.especialidade_multiprofissional_id || '',
            termo_prestador_id: this.state.termo_prestador_id || '',
            assinatura_letssign: this.state.assinatura_letssign,
            alerta_atendimento: this.state.alerta_atendimento || '',
            acesso_unico: this.state.acesso_unico || false,
            matriz_id: this.state.matriz_id || '',
            tipo_faturamento: this.state.tipo_faturamento || '',
            tipo_alvara: this.state.tipo_alvara,
            data_vencimento_alvara: this.state.data_vencimento_alvara,
            status_contrato: this.state.status_contrato,
            treinamento: this.state.treinamento,            
            tipo_prestador: this.state.tipo_prestador,            
            is_active: this.state.is_active, 
            visualizar_agendamentos_filiais: this.state.visualizar_agendamentos_filiais || false,           
        };

        if(this.state.visualizar_agendamentos_filiais == 'true') {
            dadosTratados['visualizar_agendamentos_filiais'] = true;
        } else {
            dadosTratados['visualizar_agendamentos_filiais'] = false;
        }

        if(this.state.tipo_empresa !== 'filial') {
            dadosTratados['tipo_faturamento'] = 'matriz';
        } else {
            dadosTratados['visualizar_agendamentos_filiais'] = false;
        }

        if(this.state.tipo_pessoa === 'fisica') {
            if(this.state.cpf) {
                dadosTratados['cpf_cnpj'] = this.state.cpf;
            }
        } else {
            if(this.state.cnpj) {
                dadosTratados['cpf_cnpj'] = this.state.cnpj;
            }
        }

        if(this.state.categoria != 'medicos' && this.state.categoria != 'multiprofissionais') {
            dadosTratados['registro'] = '1';
            dadosTratados['registro_uf'] = 'SP';
        } else {
            if(this.state.registro) {
                dadosTratados['registro'] = this.state.registro;
            }
            if(this.state.registro_uf) {
                dadosTratados['registro_uf'] = this.state.registro_uf;
            }
        }

        if(this.state.acesso_unico) {
            dadosTratados['cliente_id'] = cliente_id;
            dadosTratados['programa_uuid'] = programa_uuid;
        }

        if (this.state.categoria_multiprofissional_id) {
            dadosTratados.categoria_multiprofissional_id = this.state.categoria_multiprofissional_id;
        }

        Object.entries(dadosTratados).forEach(([key, value]) => {
            formData.set(key, value);
        });

        if (this.state.estados_atendimento && this.state.estados_atendimento.length > 0) {
            const estadosValues = this.state.estados_atendimento.map(option => option.value);
            formData.append('estados_atendimento', JSON.stringify(estadosValues));
        } else {
            formData.append('estados_atendimento', '[]');
        }
    
        if (this.state.imagem_upload) {
            formData.set('logomarca_pdf_termo', this.state.imagem_upload);
        }

        if (this.state.alvara instanceof File) {
            formData.set('alvara', this.state.alvara);
        }

        if (this.state.contrato_social instanceof File) {
            formData.set('contrato_social', this.state.contrato_social);
        }

        if (this.state.cartao_cnpj instanceof File) {
            formData.set('cartao_cnpj', this.state.cartao_cnpj);
        }

        if (this.state.certidao_regularidade instanceof File) {
            formData.set('certidao_regularidade', this.state.certidao_regularidade);
        }

        this.setState({loading: true});
        
        // Verifica se é gestor interno (para vínculo automático de programa após cadastro)
        const tipos_acesso = tiposAcesso();
        const isGestorInterno = tipos_acesso?.gestor 
            && tipos_acesso?.gestor.tipo_gestor === 'interno';
        const isNovoCadastro = !this.state.prestador_id;

        // Envia para API
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
            const novoPrestadorId = response.data.id;

            // Se for novo cadastro de gestor interno, vincula automaticamente o programa ao prestador
            if (isNovoCadastro && isGestorInterno && dados_usuario['ambiente_programa_id'] && dados_usuario['ambiente_cliente_id']) {
                const dadosPrograma = {
                    prestador_id: novoPrestadorId,
                    programa_id: dados_usuario['ambiente_programa_id'],
                    cliente_id: dados_usuario['ambiente_cliente_id'],
                };

                api.post('/programas/prestadores/', dadosPrograma)
                    .then(() => {
                        MySwal.fire({
                            title: <p>Provedor cadastrado e vinculado ao programa com sucesso</p>,
                            icon: 'success',
                            showCloseButton: true,
                        }).then(() => {
                            this.setState({ loading: false });
                            this.props.router.navigate("/prestadores");
                        });
                    })
                    .catch(errorPrograma => {
                        console.error('Erro ao vincular programa automaticamente:', errorPrograma);
                        MySwal.fire({
                            title: <p>Provedor cadastrado com sucesso</p>,
                            html: 'Porém não foi possível vincular o programa automaticamente. Por favor, contate a administração.',
                            icon: 'warning',
                            showCloseButton: true,
                        }).then(() => {
                            this.setState({ loading: false });
                            this.props.router.navigate(`/prestadores/${novoPrestadorId}`);
                        });
                    });
            } else {
                const textSwal = this.state.prestador_id ? 'Provedor atualizado com sucesso' : 'Provedor cadastrado com sucesso';

                MySwal.fire({
                    title: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                }).then((result) => {
                    this.setState({ loading: false });

                    // Redireciona
                    if (!this.state.prestador_id) {
                        this.props.router.navigate("/prestadores");
                    } else {
                        location.reload();
                    }
                });
            }        
        })
        .catch(error => {
            let erro_msg = "Erro ao realizar o cadastro:<br />";
    
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const responseData = error.response.data;
                const campos = responseData.erros ? responseData.erros : responseData;                     
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    erro_msg += "<br />" + key + ": " + value;

                    this.setState({ [`${key}Helper`]: value });

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'cpf_cnpj'){
                        this.setState({ 
                            cpfHelper: value,
                            cnpjHelper: value
                        })
                    }
                    if(key === 'email'){
                        this.setState({ emailHelper: value })
                    }
                    if(key === 'email_2'){
                        this.setState({ emailHelper: value })
                    }
                    if(key === 'email_3'){
                        this.setState({ emailHelper: value })
                    }
                    if(key === 'razao_social'){
                        this.setState({ razaoSocialHelper: value })
                    }
                    if(key === 'nome_fantasia'){
                        this.setState({ nomeFantasiaHelper: value })
                    }
                    if(key === 'tipo_pessoa'){
                        this.setState({ tipoPessoaHelper: value })
                    }
                    if(key === 'telefone'){
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'telefone_2'){
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'telefone_3'){
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'celular'){
                        this.setState({ celularHelper: value })
                    }
                    if(key === 'celular_2'){
                        this.setState({ celularHelper: value })
                    }
                    if(key === 'celular_3'){
                        this.setState({ celularHelper: value })
                    }
                    if(key === 'endereco'){
                        this.setState({ enderecoHelper: value })
                    }
                    if(key === 'numero'){
                        this.setState({ numeroHelper: value })
                    }
                    if(key === 'complemento'){
                        this.setState({ complementoHelper: value })
                    }
                    if(key === 'bairro'){
                        this.setState({ bairroHelper: value })
                    }
                    if(key === 'cep'){
                        this.setState({ cepHelper: value })
                    }
                    if(key === 'uf'){
                        this.setState({ ufHelper: value })
                    }
                    if(key === 'cidade'){
                        this.setState({ cidadeHelper: value })
                    }
                    if(key === 'genero'){
                        this.setState({ generoHelper: value })
                    }
                    if(key === 'registro'){
                        this.setState({ registroHelper: value })
                    }
                    if(key === 'registro_uf'){
                        this.setState({ registroUfHelper: value })
                    }
                    if(key === 'categoria'){
                        this.setState({ categoriaHelper: value })
                    }
                    if(key === 'contato_nome'){
                        this.setState({ contatoNomeHelper: value })
                    }
                    if(key === 'contato_email'){
                        this.setState({ contatoEmailHelper: value })
                    }
                    if(key === 'contato_celular'){
                        this.setState({ contatoCelularHelper: value })
                    }
                    if(key === 'logomarca_pdf_termo'){
                        this.setState({ imagemHelper: value })
                    }
                    if(key === 'tipo_faturamento'){
                        this.setState({ tipoFaturamentoHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            })      
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (event, fieldName) => {
        if(fieldName == 'beneficiario_id') {
            this.setState({ beneficiario_id: event.value, beneficiario_nome: event.label });
        }
        else if (fieldName == "servico_procedimento_id") {
            this.setState({ servico_procedimento_id: event.value, servico_procedimento_nome: event.label });
        }
        else if (fieldName == "situacao") {
            this.setState({ situacao: event.value, situacao_nome: event.label });
        }
        else if (fieldName == "valor") {
            const { name, value } = event.target;
            this.setState({ [name]: formatarValor(value) });
        }
        else if (fieldName == 'cliente_id') {
            this.setState({ 
                cliente_id: event.value, 
                cliente_nome: event.label,
                programa_uuid: '',  // Limpa o ID do programa selecionado
                programa_nome: '',  // Limpa o nome do programa selecionado
            });
        } 
        else if (fieldName == 'categoria_multiprofissional_id') {
            this.setState({ 
                categoria_multiprofissional_id: event.value, 
                categoria_multiprofissional_nome: event.label,
            });
        } 
        else if (fieldName == 'especialidade_multiprofissional_id') {
            this.setState({ 
                especialidade_multiprofissional_id: event.value, 
                especialidade_multiprofissional_nome: event.label,
            });
        } 
        else if (fieldName == 'programa_uuid') {
            this.setState({ 
                programa_uuid: event.value, 
                programa_nome: event.label,
            });
        } 
        else if (fieldName == 'termo_prestador_id'){
            this.setState({ 
                termo_prestador_id: event.value, 
                termo_prestador_nome: event.label,
            });
        } 
        else if (fieldName == 'assinatura_letssign'){
            this.setState({ 
                assinatura_letssign: event.target.checked
            });
        } else if (fieldName == 'tipo_empresa'){
            const { name, value } = event.target;
            this.setState({ [name]: value }, () => {
                if(value == 'filial'){
                    this.setState({ visualizar_agendamentos_filiais: 'false' });
                } 
            });
        }
        else if (fieldName == 'matriz_id'){
            this.setState({ 
                matriz_id: event.value, 
                matriz_nome: event.label,
            });
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    handleChangeCamposObrigatorios = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleEspecialidadesChange= (selectedOption, index) => {
        this.setState({ especialidades: selectedOption});
    };

    handleChangeUsuarios = (e) => {
        const { name, type, checked, value } = e.target;

        const fieldValue = type === 'checkbox' ? checked : value;

        this.setState((prevState) => ({
            usuarioAtual: {
            ...prevState.usuarioAtual,
            [name]: fieldValue,
            },
            errors: {
            ...prevState.errors,
            [name]: null,
            },
        }));
    };

    handleChangeUsuariosSelect = (fieldName) => (selectedOption) => {
        this.setState((prevState) => ({
            usuarioAtual: {
                ...prevState.usuarioAtual,
                [fieldName]: selectedOption,
            },
            usuarioErrors: {
                ...prevState.usuarioErrors,
                [fieldName]: null,
            },
        }));
    };

    onChangeImagem = (e) => {
        this.setState({ imagem_upload: e.target.files[0] });
    };

    onChangeTipoPessoa = (e) => {
        this.setState({
            tipo_pessoa: e.target.value,
            cpf: '',
            cnpj: '',
        });
    };

    onChangeGrupo = (grupoSelecionado) => {
        this.setState({ grupo_id: grupoSelecionado ? grupoSelecionado.value : '', grupo_nome: grupoSelecionado ? grupoSelecionado.label : '' });
    };

    /*
    onChangeCategoria = (categoriaSelecionado) => {
        this.setState({ categoria_multiprofissional_id: categoriaSelecionado ? categoriaSelecionado.value : '', categoria_multiprofissional_nome: categoriaSelecionado ? categoriaSelecionado.label : '' });
    };*/

    onChangeCep = (maskedOrRaw) => {
        const raw = String(maskedOrRaw || "").replace(/\D/g, ""); // "89285705"
        const masked = raw.replace(/^(\d{5})(\d{0,3})$/, "$1-$2"); // "89285-705" (quando tiver 6-8 dígitos)

        this.setState({ cep: masked, cepHelper: "" });

        // debounce: espera o usuário parar de digitar/colar
        clearTimeout(buscaCepTimer);
        buscaCepTimer = setTimeout(() => {
            if (raw.length === 8) this.buscarViaCep(masked);
        }, 250);
    }

    buscarViaCep = async (maskedCep) => {
        const raw = String(maskedCep || "").replace(/\D/g, "");
        if (raw.length !== 8) return;

        try {
            // opcional: cancelar requisições anteriores para evitar race conditions
            this._viaCepController?.abort();
            this._viaCepController = new AbortController();

            const res = await axios.get(`https://viacep.com.br/ws/${raw}/json/`, {
                signal: this._viaCepController.signal
            });

            if (!res.data?.erro) {
                this.setState(prev => ({
                    endereco: res.data.logradouro || "",
                    complemento: res.data.complemento || prev.complemento,
                    bairro: res.data.bairro || "",
                    cidade: res.data.localidade || "",
                    uf: res.data.uf || "",
                    cepHelper: ""
                }));
            } else {
                this.setState({ cepHelper: "CEP não encontrado." });
            }
        } catch (error) {
            if (error.name === "CanceledError" || error.code === "ERR_CANCELED") return;
            console.error("Erro na requisição do CEP:", error);
            this.setState({ cepHelper: "Falha ao consultar o CEP. Tente novamente." });
        }
    };

    mostrarMaisEmail = () => {
        if (!this.state.mostrarEmail2) {
            this.setState({ mostrarEmail2: true });
        } else if (!this.state.mostrarEmail3) {
            this.setState({ mostrarEmail3: true });
        }
    };

    mostrarMaisTelefone = () => {
        if (!this.state.mostrarTelefone2) {
            this.setState({ mostrarTelefone2: true });
        } else if (!this.state.mostrarTelefone3) {
            this.setState({ mostrarTelefone3: true });
        }
    };

    mostrarMaisCelular = () => {
        if (!this.state.mostrarCelular2) {
            this.setState({ mostrarCelular2: true });
        } else if (!this.state.mostrarCelular3) {
            this.setState({ mostrarCelular3: true });
        }
    };

    carregarClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    //Laboratórios do Médico
    carregarLaboratoriosMedico = () => {
        if (this.state.prestador_id) {
            api.get(`/pessoas/prestadores/laboratorios/?medico_id=${this.state.prestador_id}`)
                .then(response => {
                    const laboratoriosCarregados = response.data.results.map(laboratorio => ({
                        id: laboratorio.id,
                        laboratorio_id: laboratorio.laboratorio_id,
                        laboratorio_nome: `${laboratorio.dados_laboratorio.nome_fantasia} (${laboratorio.dados_laboratorio.razao_social})`
                    }));
                    this.setState({ laboratorios: laboratoriosCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar laboratórios:', error);
                    
                    let erro_msg = 'Erro ao carregar laboratórios do médico, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    salvarLaboratorio = (index) => {
        const laboratorio = this.state.laboratorios[index];
        const url = (laboratorio.id) ? `/pessoas/prestadores/laboratorios/${laboratorio.id}/` : '/pessoas/prestadores/laboratorios/';
        const metodo = (laboratorio.id) ? 'put' : 'post';
    
        const dadosLaboratorio = {
            medico_id: this.state.prestador_id,
            laboratorio_id: laboratorio.laboratorio_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosLaboratorio,
        })
        .then(response => {
            // Se for um novo laboratorio, atualize o estado com a ID retornada pela API
            if (!laboratorio.id) {
                this.setState(prevState => {
                    const laboratoriosAtualizados = [...prevState.laboratorios];
                    laboratoriosAtualizados[index].id = response.data.id;
                    return { laboratorios: laboratoriosAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (laboratorio.id) ? 'Laboratório atualizado com sucesso' : 'Laboratório cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o laboratório, verifique os campos e tente novamente';   
            let content = '';         

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'laboratorio_id') {
                        content += `<br>&bull; Laboratório: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    adicionarLaboratorio = () => {
        this.setState(prevState => ({
            laboratorios: [...prevState.laboratorios, { laboratorio_id: '', laboratorio_nome: '' }],
        }));
    };

    removerLaboratorio = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover laboratório?',
            text: "Tem certeza que deseja remover este laboratório?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const laboratorio = this.state.laboratorios[index];

                if (laboratorio.id) {

                    const url = `/pessoas/prestadores/laboratorios/${laboratorio.id}/`;
                    const metodo = 'delete';
                
                    api({
                        method: metodo,
                        url: url,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Laboratório removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            laboratorios: prevState.laboratorios.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o laboratório, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        laboratorios: prevState.laboratorios.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O laboratório foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleLaboratorioChange = (index, event, fieldName) => {
        const laboratorios = [...this.state.laboratorios];
        if (fieldName === 'laboratorio_id') {
            laboratorios[index] = { ...laboratorios[index], laboratorio_id: event.value, laboratorio_nome: event.label };
        } else {
            const { name, value } = event.target;
            laboratorios[index] = { ...laboratorios[index], [name]: value };
        }
        this.setState({ laboratorios });
    };

    carregarLaboratorios = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/prestadores/?nome=${inputValue}&categoria=laboratorio_diagnostico|servicos_diagnostico|clinicas|hospitais|cooperativas_saude`);
            const opcoes = response.data.results.map(laboratorio => ({
                value: laboratorio.id,
                label: `${laboratorio.nome_fantasia} (${laboratorio.razao_social})`
            }));
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar laboratorios:', error);
            return [];
        }
    };

    carregarClientesPrograma = async (inputValue) => {
        const dados_usuario = getCurrentUser();
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}&tipo_usuario=${dados_usuario['tipo_usuario']}`);
            let opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));

            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };


    carregarProgramasCliente = async (inputValue, cliente_id) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.uuid,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas do cliente:', error);
            return [];
        }
    };

    carregarProgramasClienteRepetidor = async (inputValue, cliente_id) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas do cliente:', error);
            return [];
        }
    };

    carregarTermos = async (inputValue) => {
        try{
            const response = await api.get(`/termos/?titulo=${inputValue}`);
            const opcoes = response.data.results.map(termo => ({
                value: termo.id,
                label: termo.titulo
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar termos:', error);
            return [];
        }
    }

    carregarEspecialidades = async (inputValue) => {
        try {
            const response = await api.get(`/profissionais/especialidades-medicas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(especialidade => ({
                value: especialidade.id,
                label: especialidade.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar especialidades:', error);
            return [];
        }
    };

    carregarCategoriaMultiprofissional = async (inputValue) => {
        try {
            const response = await api.get(`/profissionais/categorias-multiprofissionais/?nome=${inputValue}`);
            const opcoes = response.data.results.map(categoria => ({
                value: categoria.id,
                label: categoria.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar especialidades:', error);
            return [];
        }
    };

    carregarEspecialidadeMultiprofissional = async (inputValue) => {
        try {
            const response = await api.get(`/profissionais/especialidade-multiprofissionais/?nome=${inputValue}`);
            const opcoes = response.data.results.map(multiprofissionais => ({
                value: multiprofissionais.id,
                label: multiprofissionais.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar especialidades:', error);
            return [];
        }
    };

    //Programas do Prestador
    carregarProgramasPrestador = () => {
        if (this.state.prestador_id) {
            api.get(`/programas/prestadores/?prestador_id=${this.state.prestador_id}`)
                .then(response => {
                    console.log(response)
                    const programasCarregados = response.data.results.map(programa => ({
                        id: programa.id,
                        programa_id: programa.programa_id,
                        programa_nome: programa.dados_programa.nome,
                        termo_prestador_id: programa.termo_prestador_id,
                        termo_prestador_nome: programa.dados_termo_prestador.nome,
                        data_aceite_termo: programa.data_aceite_termo,
                        cliente_id: programa.cliente_id,
                        assinatura_letssign: programa.assinatura_letssign,
                        alerta_atendimento: programa.alerta_atendimento,
                        exclusivo_vinculados: programa.exclusivo_vinculados,
                        cliente_nome: `${programa.dados_cliente.nome_fantasia} (${programa.dados_cliente.razao_social})`
                    }));
                    this.setState({ programas: programasCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar programas:', error);
                    
                    let erro_msg = 'Erro ao carregar programas do provedor, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    carregarMatrizes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/prestadores/?nome=${inputValue}&tipo_empresa=matriz&tipo_pessoa=juridica`);
            const opcoes = response.data.results.map(matriz => ({
                value: matriz.id,
                label: `${matriz.nome_fantasia} (${matriz.razao_social})`
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar matrizes:', error);
            return [];
        }
    };

    salvarPrograma = (index) => {
        const programa = this.state.programas[index];
        const url = (programa.id) ? `/programas/prestadores/${programa.id}/` : '/programas/prestadores/';
        const metodo = (programa.id) ? 'put' : 'post';
    
        const dadosPrograma = {
            prestador_id: this.state.prestador_id,
            cliente_id: programa.cliente_id,
            programa_id: programa.programa_id,
            assinatura_letssign: programa.assinatura_letssign,
            exclusivo_vinculados: programa.exclusivo_vinculados || false
        };

        if(programa.alerta_atendimento) {
            dadosPrograma['alerta_atendimento'] = programa.alerta_atendimento;
        }

        if(programa.termo_prestador_id) {
            dadosPrograma['termo_prestador_id'] = programa.termo_prestador_id;
        }

        api({
            method: metodo,
            url: url,
            data: dadosPrograma,
        })
        .then(response => {
            // Se for um novo programa, atualize o estado com a ID retornada pela API
            if (!programa.id) {
                this.setState(prevState => {
                    const programasAtualizados = [...prevState.programas];
                    programasAtualizados[index].id = response.data.id;
                    return { programas: programasAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (programa.id) ? 'Programa atualizado com sucesso' : 'Programa cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o programa, verifique os campos e tente novamente';   
            let content = '';         

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'programa_id') {
                        content += `<br>&bull; Programa: ${value}`;
                    }
                    if(key == 'cliente_id') {
                        content += `<br>&bull; Cliente: ${value}`;
                    }
                    if(key == 'termo_prestador_id') {
                        content += `<br>&bull; Termo: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    adicionarPrograma = () => {
        this.setState(prevState => ({
            programas: [...prevState.programas, { cliente_id: '', cliente_nome: '', programa_id: '', programa_nome: '', termo_prestador_id: '', termo_prestador_nome: '', data_aceite_termo: '', assinatura_letssign: false, 'alerta_atendimento': '', exclusivo_vinculados: '' }],
        }));
    };

    removerPrograma = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover programa?',
            text: "Tem certeza que deseja remover este programa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const programa = this.state.programas[index];

                if (programa.id) {

                    const url = `/programas/prestadores/${programa.id}/`;
                    const metodo = 'delete';
                
                    api({
                        method: metodo,
                        url: url,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Programa removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            programas: prevState.programas.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o programa, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        programas: prevState.programas.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O programa foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleProgramaChange = (index, event, fieldName) => {
        const programas = [...this.state.programas];
        if (fieldName === 'cliente_id') {
            // Reseta o programa quando o cliente é alterado
            programas[index] = {
                ...programas[index],
                cliente_id: event.value,
                cliente_nome: event.label,
                programa_id: '',  // Limpa o ID do programa selecionado
                programa_nome: '',  // Limpa o nome do programa selecionado
                // Adiciona uma chave para forçar a re-renderização do AsyncSelect de programas
                keyPrograma: new Date().getTime()
            };
        } else if (fieldName === 'programa_id') {
            programas[index] = { ...programas[index], programa_id: event.value, programa_nome: event.label };
        } else if (fieldName === 'termo_prestador_id'){
            programas[index] = { ...programas[index], termo_prestador_id: event.value, termo_prestador_nome: event.label };
        } else if (fieldName === 'assinatura_letssign'){
            programas[index] = { ...programas[index], assinatura_letssign: event.target.checked };
        } else if (fieldName === 'alerta_atendimento'){
            programas[index] = { ...programas[index], alerta_atendimento: event.target.value };
        }
        else if (fieldName === 'exclusivo_vinculados'){
            programas[index] = { ...programas[index], exclusivo_vinculados: event.target.checked };
        }

        this.setState({ programas });
    };

    // Função para alternar a visibilidade da senha
    toggleSenhaVisibilidade = campo => {
        this.setState(prevState => ({
            mostrarSenha: { ...prevState.mostrarSenha, [campo]: !prevState.mostrarSenha[campo] }
        }));
    }

    carregarGrupos = async (inputValue) => {
        try {
            const response = await api.get(`/grupos/?nome=${inputValue}`);
            
            // Lista de nomes permitidos
            const nomesPermitidos = [
                'Laboratórios',
                'Laboratórios/Clínicas',
                'Laboratórios - Nutricionistas - Psicólogos',
                'Medimentor Mentorado',
                'Medimentor Prestador',
                'Médicos Prestadores',
                "Multiprofissionais",
                'Transporte'
            ];
            
            // Filtrar os grupos com base nos nomes permitidos
            const opcoes = response.data.results
                .filter(grupo => nomesPermitidos.includes(grupo.name))
                .map(grupo => ({
                    value: grupo.id,
                    label: grupo.name
                }));
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar grupos:', error);
            return [];
        }
    };

    logomarcaTermo() {
        const renderTooltip = (props) => (
            <Tooltip id="button-tooltip" {...props}>
              Logomarca que é exibida no cabeçalho do termo PDF do laboratório e que é assinado pelo paciente
            </Tooltip>
          );

          return (
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <Button variant="tooltip" size="sm">?</Button>
            </OverlayTrigger>
          );
        }

    // Carregar serviços do prestador
    carregarServicosPrestador = () => {
        if (!this.state.prestador_id) return;

        this.setState({ loadingServicos: true });
        
        api.get(`/pessoas/prestadores/servicos_procedimentos/?prestador_id=${this.state.prestador_id}&status=1`)
        .then(response => {
            const servicosCarregados = response.data.results.map(
                this.normalizarServicoPrestador
            );

            this.setState({
                servicos: servicosCarregados,
                servicosData: response.data, 
                loadingServicos: false
            });
        })
        .catch(() => {
            this.setState({ loadingServicos: false });
        });
    };

    normalizarServicoPrestador = (servico) => ({
        id: servico.id,
        servico_id: servico.servico_procedimento_id,
        servico_nome: servico.dados_servico_procedimento?.nome ?? '',
        valor: formatarValorLocal(servico.valor),
        valor_parceiros: formatarValorLocal(servico.valor_parceiros),
        valor_compra: formatarValorLocal(servico.valor_compra),
        status: servico.status
    });

    carregarUsuariosPrestador = () => {
        if (!this.state.prestador_id) return;

        this.setState({ loading: true });
        
        api.get(`/usuarios/?prestador_id=${this.state.prestador_id}`)
        .then(response => {
            const usuariosCarregados = response.data.results.map(usuario => {
                const grupos = usuario.grupos_list || []; 
                const primeiroGrupo = grupos.length > 0 ? { value: grupos[0].id, label: grupos[0].name } : null;

                return {
                    id: usuario.id,
                    first_name: usuario.first_name,
                    last_name: usuario.last_name,
                    email: usuario.email,
                    username: usuario.username,
                    is_active: usuario.is_active,
                    last_login: usuario.last_login,
                    grupo_id: primeiroGrupo,
                };
            });

            this.setState({ 
                usuarios: usuariosCarregados,
                loading: false 
            });
        })
        .catch(error => {
            console.error('Erro ao carregar usuários:', error);
            this.setState({ loading: false });
        });
    };

    // Carregar serviços disponíveis para vincular
    carregarServicosDisponiveis = async (inputValue) => {
        try {
            const response = await api.get(`/servicos_procedimentos/?nome=${inputValue}`);
            return response.data.results.map(servico => ({
                value: servico.id,
                label: servico.nome
            }));
        } catch (error) {
            console.error('Erro ao carregar serviços disponíveis:', error);
            return [];
        }
    };

    carregarServicosFiltro = async (inputValue) => {
        try {
            const response = await api.get(
                `/servicos_procedimentos/?nome=${inputValue}`
            );

            return response.data.results.map(servico => ({
                value: servico.id,
                label: servico.nome
            }));
        } catch (error) {
            console.error('Erro ao carregar serviços', error);
            return [];
        }
    };

    // Herdar serviços da matriz
    herdarServicosMatriz = () => {
        if (!this.state.matriz_id) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Matriz não definida para este provedor',
                showConfirmButton: true
            });
            return;
        }

        const MySwal = withReactContent(Swal);
        MySwal.fire({
            icon: 'question',
            title: 'Confirmar Herança de Serviços',
            text: 'Deseja realmente herdar os serviços da matriz? Isso substituirá os serviços atuais.',
            showCancelButton: true,
            confirmButtonText: 'Sim, herdar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loadingServicos: true });

                api.post('/pessoas/prestadores/servicos_procedimentos/herdar/', {
                    prestador_de: this.state.matriz_id,
                    prestador_para: this.state.prestador_id
                })
                .then(response => {
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'success',
                        title: 'Sucesso',
                        text: 'Serviços herdados com sucesso',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.carregarServicosPrestador();
                })
                .catch(error => {
                    console.error('Erro ao herdar serviços:', error);
                    this.setState({ loadingServicos: false });
                    
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Não foi possível herdar os serviços da matriz',
                                showConfirmButton: true
                    });
                });
            }
        });
    };

    handleShowModalServico = (servico = null) => {
        if (servico) {
            this.setState({
                servicoAtual: {
                    id: servico.id,
                    servico_id: servico.servico_id,
                    servico_nome: servico.servico_nome,
                    valor: servico.valor,
                    valor_parceiros: servico.valor_parceiros,
                    valor_compra: servico.valor_compra,
                    ativo: servico.ativo
                },
                showModalServico: true
            });
        } else {
            this.setState({
                servicoAtual: {
                    id: '',
                    servico_id: '',
                    servico_nome: '',
                    valor: '',
                    valor_parceiros: '',
                    valor_compra: '',
                    ativo: true
                },
                showModalServico: true
            });
        }
    };

    consultaServicos = async (page = 1) => {
        this.setState({ loadingServicos: true });

        try {
            const { prestador_id, filtro_id_faturamento } = this.state;

            let url = `/pessoas/prestadores/servicos_procedimentos/?prestador_id=${prestador_id}&page=${page}`;

            if (this.state.filtro_servico_id) {
                url += `&servico_procedimento_id=${this.state.filtro_servico_id}`;
            }

            const response = await api.get(url);

            this.setState({
                servicosData: response.data,
                servicos: response.data.results.map(this.normalizarServicoPrestador),
                page_servicos: page,
                loadingServicos: false
            });
        } catch (error) {
            this.setState({
                servicosData: {},
                servicos: [],
                loadingServicos: false
            });
        }
    };

    onClickPaginaServicos = (num_page) => {
        this.consultaServicos(num_page);
    };

    filtrarServico = (e) => {
        e.preventDefault();
        this.consultaServicos(1);
    };

    limpaFiltro = () => {
        this.setState(
            {
                filtro_servico_id: '',
                filtro_servico_nome: ''
            },
            () => this.consultaServicos(1)
        );
    };

    handleShowModalUsuario = (usuario = null) => {
        this.setState({ usuarioErrors: {} });

        if (usuario) {
            this.setState({
                usuarioAtual: {
                    id: usuario.id,
                    email: usuario.email,
                    username: usuario.username,
                    is_active: usuario.is_active,
                    first_name: usuario.first_name,
                    last_name: usuario.last_name,
                    grupo_id: usuario.grupo_id,
                },
                showModalUsuario: true
            });
        } else {
            this.setState({
                usuarioAtual: {
                    id: '',
                    email: '',
                    username: '',
                    is_active: true,
                    first_name: '',
                    last_name: '',
                    grupo_id: ''
                },
                showModalUsuario: true
            });
        }
    };

    handleCloseModalUsuario = () => {
        this.setState({ 
            showModalUsuario: false,
        });
    };

    handleCloseModalServico = () => {
        this.setState({ 
            showModalServico: false,
            replicarParaFiliais: false
        });
    };

    handleRemoverServico = (id, servico_id) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            icon: 'warning',
            title: 'Atenção',
            text: 'Tem certeza que deseja remover este serviço?',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const url = `/pessoas/prestadores/servicos_procedimentos/${id}/`;
                    const metodo = 'put';

                    await api({
                        method: metodo,
                        url: url,
                        data: {
                            status: false
                        }
                    }) 
                    .then(response => {
                        const MySwal = withReactContent(Swal);
                        MySwal.fire({
                            icon: 'success',
                            title: 'Sucesso',
                            text: 'Serviço removido com sucesso',
                            showConfirmButton: false,
                            timer: 1500
                        });

                        if (this.state.tipo_empresa === 'matriz' && this.state.filiais.length > 0) {
                            const MySwal = withReactContent(Swal);
                            MySwal.fire({
                                icon: 'question',
                                title: 'Remover para Filiais',
                                text: 'Deseja remover este serviço para todas as filiais?',
                                showCancelButton: true,
                                confirmButtonText: 'Sim',
                                cancelButtonText: 'Não'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    api.post('/pessoas/prestadores/servicos_procedimentos/herdar/', {
                                        prestador_de: this.state.prestador_id,
                                        replicar_filiais: true,
                                        servico_id: servico_id
                                    })
                                    .then(() => {
                                        const MySwal = withReactContent(Swal);
                                        MySwal.fire({
                                            icon: 'success',
                                            title: 'Sucesso',
                                            text: 'Serviço removido para todas as filiais',
                                            showConfirmButton: false,
                                            timer: 1500
                                        });
                                    })
                                    .catch(error => {
                                        console.error('Erro ao remover serviço:', error);
                                        const MySwal = withReactContent(Swal);
                                        MySwal.fire({
                                            icon: 'error',
                                            title: 'Erro',
                                            text: 'Não foi possível remover o serviço para as filiais',
                                            showConfirmButton: true
                                        });
                                    });
                                }
                            });
                        }
                        this.carregarServicosPrestador();
                        
                    })
                    .catch(error => {
                        console.error('Erro ao remover serviço:', error);
                    });
                } catch (error) {
                    console.error('Erro ao remover serviço:', error);
                }
            }
        });
    };

    handleChangeServico = (e, field) => {
        if (field === 'servico_id') {
            this.setState(prevState => ({
                servicoAtual: {
                    ...prevState.servicoAtual,
                    servico_id: e.value,
                    servico_nome: e.label
                }
            }));
        } else if (field === 'valor') {
            this.setState(prevState => ({
                servicoAtual: {
                    ...prevState.servicoAtual,
                    valor: e.formattedValue
                }
            }));
        } else if (field === 'valor_parceiros') {
            this.setState(prevState => ({
                servicoAtual: {
                    ...prevState.servicoAtual,
                    valor_parceiros: e.formattedValue
                }
            }));
        } else if (field === 'valor_compra') {
            this.setState(prevState => ({
                servicoAtual: {
                    ...prevState.servicoAtual,
                    valor_compra: e.formattedValue
                }
            }));
        } else {
            const { name, value, type, checked } = e.target;
            this.setState(prevState => ({
                servicoAtual: {
                    ...prevState.servicoAtual,
                    [name]: type === 'checkbox' ? checked : value
                }
            }));
        }
    };

    /*onChangeArquivo = (e) => {
        if (e.target.files && e.target.files[0]) {
            const { name, files } = e.target;
            const arquivo_enviado = files[0];

            this.setState({ [name]: arquivo_enviado });
        }
    };*/

    onChangeArquivo = (e) => {
        const { name, files } = e.target;
        const file = files[0];

        if (!file) return;

        const dadosValidos = ['image/png', 'image/jpeg', 'application/pdf'];
        if (!dadosValidos.includes(file.type)) {
            Swal.fire({
                icon: 'error',
                title: 'Formato inválido',
                text: 'Apenas arquivos PNG, JPG, JPEG e PDF são permitidos.',
                confirmButtonText: 'Ok'
            });
            e.target.value = '';
            return;
        }

        const previewURL = URL.createObjectURL(file);

        this.setState({
            uploadFile: file,
            uploadPreview: previewURL,
            nomeCampoUpload: name,
            showModalConfirmacao: true
        });
    };
    

    handleConfirmarUpload = () => {
        this.setState((prevState) => ({
            [prevState.nomeCampoUpload]: prevState.uploadFile,
            uploadFile: null,
            uploadPreview: null,
            nomeCampoUpload: '',
            showModalConfirmacao: false
        }));
    };

    handleCancelarUpload = () => {
        this.setState({
            uploadFile: null,
            uploadPreview: null,
            nomeCampoUpload: '',
            showModalConfirmacao: false
        });

        //Limpar campos
        switch (this.state.nomeCampoUpload) {
            case 'alvara':
                if (this.fileInputAlvara.current) this.fileInputAlvara.current.value = '';
                break;
            case 'contrato_social':
                if (this.fileInputContrato.current) this.fileInputContrato.current.value = '';
                break;
            case 'certidao_regularidade':
                if (this.fileInputCertidao.current) this.fileInputCertidao.current.value = '';
                break;
            case 'cartao_cnpj':
                if (this.fileInputCNPJ.current) this.fileInputCNPJ.current.value = '';
                break;
            default:
                break;
        }
    };

    handleSubmitServico = (e) => {
        e.preventDefault();
        const { servicoAtual, prestador_id } = this.state;

        if (!servicoAtual.servico_id) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Selecione um serviço',
                showConfirmButton: true
            });
            return;
        }

        console.log(servicoAtual);
        
        let valor = formatarValorAPI(servicoAtual.valor);
        let valor_parceiros = formatarValorAPI(servicoAtual.valor_parceiros);
        let valor_compra = formatarValorAPI(servicoAtual.valor_compra);

        const payload = {
            prestador_id,
            servico_procedimento_id: servicoAtual.servico_id,
            status: servicoAtual.ativo
        };

        if (valor > 0) {
            payload['valor'] = formatarValorAPI(servicoAtual.valor);
        }

        if (valor_parceiros > 0) {
            payload['valor_parceiros'] = formatarValorAPI(servicoAtual.valor_parceiros);   
        }

        if (valor_compra > 0) {
            payload['valor_compra'] = formatarValorAPI(servicoAtual.valor_compra);
        }

        const method = servicoAtual.id ? 'put' : 'post';
        const url = servicoAtual.id 
            ? `/pessoas/prestadores/servicos_procedimentos/${servicoAtual.id}/`
            : '/pessoas/prestadores/servicos_procedimentos/';

        api({
            method,
            url,
            data: payload
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'success',
                title: 'Sucesso',
                text: servicoAtual.id ? 'Serviço atualizado com sucesso' : 'Serviço adicionado com sucesso',
                showConfirmButton: false,
                timer: 1500
            });

            if (this.state.tipo_empresa === 'matriz' && this.state.filiais.length > 0) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'question',
                    title: 'Replicar para Filiais',
                    text: 'Deseja replicar este serviço para todas as filiais?',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then((result) => {
                    if (result.isConfirmed) {
                        api.post('/pessoas/prestadores/servicos_procedimentos/herdar/', {
                            prestador_de: this.state.prestador_id,
                            replicar_filiais: true
                        })
                        .then(() => {
                            const MySwal = withReactContent(Swal);
                            MySwal.fire({
                                icon: 'success',
                                title: 'Sucesso',
                                text: 'Serviço replicado para todas as filiais',
                                showConfirmButton: false,
                                timer: 1500
                            });
                        })
                        .catch(error => {
                            console.error('Erro ao replicar serviço:', error);
                            const MySwal = withReactContent(Swal);
                            MySwal.fire({
                                icon: 'error',
                                title: 'Erro',
                                text: 'Não foi possível replicar o serviço para as filiais',
                                showConfirmButton: true
                            });
                        });
                    }
                });
            }
            this.carregarServicosPrestador();
            this.handleCloseModalServico();
        })
        .catch(error => {
            console.error('Erro ao salvar serviço:', error);
            
            let mensagem = 'Erro ao salvar serviço';
            if (error.response && error.response.data) {
                if (typeof error.response.data === 'object') {
                    mensagem = Object.values(error.response.data).join(', ');
                } else {
                    mensagem = error.response.data;
                }
            }
            
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Erro',
                text: mensagem,
                showConfirmButton: true
            });
        });
    };

    handleSubmitUsuario = (e) => {
        e.preventDefault();
        const { usuarioAtual, prestador_id } = this.state;       

        const errors = {};

        if (!usuarioAtual.first_name) {
            errors.nome = 'Nome é obrigatório';
        }

        if (!usuarioAtual.last_name) {
            errors.nome = 'Sobrenome é obrigatório';
        }

        if (!usuarioAtual.username) {
            errors.username = 'Nom de usuário é obrigatório';
        }

        if (Object.keys(errors).length > 0) {
            this.setState({ usuarioErrors: errors });
            return;
        }

        const payload = {
            is_active: usuarioAtual.is_active,
            first_name: usuarioAtual.first_name,
            last_name: usuarioAtual.last_name,
            email: usuarioAtual.email,
            username: usuarioAtual.username,            
            grupos: [usuarioAtual.grupo_id ? usuarioAtual.grupo_id.value : null]
        };        

        // cadastro
        if(!usuarioAtual.id){

            if (!validaSenha(usuarioAtual.password)) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'warning',
                    title: 'Atenção',
                    text: 'Sua senha deve ter mais de 8 caracteres, incluir pelo menos uma letra maiúscula, uma letra minúscula, um número e um caractere especial.',
                    showCloseButton: true,
                });
                return;
            }
    
            if (usuarioAtual.password !== usuarioAtual.password_confirm) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'waring',
                    title: 'Atenção!',
                    text: 'As senhas não coincidem.',
                    showCloseButton: true,
                });
                return;
            }

            // senha
            payload['password'] = usuarioAtual.password

            // restricoes
            payload['restricoes'] = {
                'id': prestador_id,
                'tipo': 'prestador'
            }            
        }

        const method = usuarioAtual.id ? 'put' : 'post';
        const url = usuarioAtual.id 
            ? `/usuarios/${usuarioAtual.id}/`
            : '/usuarios/';
        
        this.setState({ loading: true });

        api({
            method,
            url,
            data: payload
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'success',
                title: 'Sucesso',
                text: usuarioAtual.id ? 'Usuário atualizado com sucesso' : 'Usuário adicionado com sucesso',
                showConfirmButton: false,
                timer: 1500
            });

            this.setState({ usuarioErrors: {}, loading: false });

            this.carregarUsuariosPrestador();
            this.handleCloseModalUsuario();
        })
        .catch(error => {
            console.error('Erro ao salvar usuário:', error);

            const errorsFromApi = {};
            let mensagem = 'Erro ao salvar o usuário, verifique os campos.';
            let isGenericError = false;

            if (error.response && error.response.data) {
                const data = error.response.data;

                if (typeof data === 'object') {
                    // Ex.: DRF: { "nome": ["Este campo é obrigatório."], "detail": "..." }
                    Object.entries(data).forEach(([field, msg]) => {
                        const text = Array.isArray(msg) ? msg.join(' ') : String(msg);

                        if (field === 'detail' || field === 'non_field_errors') {
                            // erro mais genérico da API
                            mensagem = text;
                            isGenericError = true;
                        } else {
                            // erro de campo
                            errorsFromApi[field] = text;
                        }
                    });

                    // se só tiver erro de campo, mantém mensagem genérica
                    if (!isGenericError) {
                        mensagem = 'Erro ao salvar o usuário, verifique os campos.';
                    }
                } else {
                    // quando a API retorna uma string simples
                    mensagem = data;
                    isGenericError = true;
                }
            } else {
                // sem resposta da API (timeout, rede, etc.)
                mensagem = 'Erro ao salvar usuário. Tente novamente mais tarde.';
                isGenericError = true;
            }

            // joga erros de campo pro formulário
            if (Object.keys(errorsFromApi).length > 0) {
                this.setState(prev => ({
                    usuarioErrors: {
                        ...prev.usuarioErrors,
                        ...errorsFromApi,
                    },
                }));
            }

            this.setState({ loading: false });

            // aqui você pode:
            // - sempre mostrar SweetAlert (com msg genérica ou da API)
            // - OU mostrar apenas pra erro genérico:
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Erro',
                text: mensagem,
                showConfirmButton: true,
            });
        });
    };

    // Renderizar aba de serviços
    renderServicosTab = () => {
        const { tipo_empresa, matriz_id } = this.state;
        
        return (
            <Tab eventKey="servicos" title="Serviços e Procedimentos">
                <Card className="cardDestaque mt-4">
                    <Card.Body>
                            <Row className="align-items-center">
                                <Col sm={4} xs={12}> 
                                    <Form method="get" onSubmit={this.filtrarServico}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Selecione um serviço para filtrar:</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregarServicosFiltro}
                                                defaultOptions
                                                placeholder="Buscar serviço..."
                                                noOptionsMessage={() => 'Nenhum serviço encontrado'}
                                                onChange={(option) => {
                                                    this.setState({
                                                        filtro_servico_id: option ? option.value : '',
                                                        filtro_servico_nome: option ? option.label : ''
                                                    });
                                                }}
                                                value={this.state.filtro_servico_id ? { value: this.state.filtro_servico_id, label: this.state.filtro_servico_nome} : null}
                                                isClearable
                                            />
                                        </Form.Group>
                                        <Button type="submit" variant="secondary" size="sm">
                                            <FaSearch /> Filtrar
                                        </Button>
                                        <Button type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                            <FaEraser /> Limpar Filtro
                                        </Button>
                                    </Form>
                                </Col>
                                <Col sm={8} xs={12} className="text-end mb-3">
                                    <Button 
                                        variant="success" 
                                        size="sm"
                                        onClick={() => this.handleShowModalServico()}
                                    >
                                        <FaPlus className="me-2" /> Adicionar Serviço
                                    </Button>
                                    {tipo_empresa === 'filial' && matriz_id && (
                                        <Button 
                                            variant="secondary" 
                                            size="sm"
                                            className="ms-2"
                                            onClick={this.herdarServicosMatriz}
                                        >
                                            <FaSync className="me-1" /> Herdar Serviços da Matriz
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                                

                        <Table responsive className="custom-table mt-3">
                            <thead>
                                <tr>
                                    <th>Serviço ID</th>
                                    <th>Serviço</th>
                                    <th>Valor</th>
                                    <th>Valor para parceiros</th>
                                    <th>Valor de compra</th>
                                    <th>Status</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loadingServicos ? (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            Carregando...
                                        </td>
                                    </tr>
                                ) : this.state.servicos.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            Nenhum serviço vinculado
                                        </td>
                                    </tr>
                                ) : (
                                    this.state.servicos.map(servico => (
                                        <tr key={servico.id}>
                                            <td>{servico.servico_id}</td>
                                            <td>{servico.servico_nome}</td>
                                            <td>{servico.valor ? servico.valor : ''}</td>
                                            <td>{servico.valor_parceiros ? servico.valor_parceiros : ''}</td>
                                            <td>{servico.valor_compra ? servico.valor_compra : ''}</td>
                                            <td>
                                                {servico.status ? 'Ativo' : 'Inativo'}
                                            </td>
                                            <td>
                                                <Button 
                                                    variant="secondary" 
                                                    size="sm"
                                                    onClick={() => this.handleShowModalServico(servico)}
                                                >
                                                    Editar
                                                </Button>
                                                <Button 
                                                    variant="danger" 
                                                    size="sm"
                                                    className="ms-2"
                                                    onClick={() => this.handleRemoverServico(servico.id, servico.servico_id)}
                                                >
                                                    Remover
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                        {this.state.servicosData?.results?.length > 0 && (
                            <Paginacao
                                dados={this.state.servicosData}
                                loading={this.state.loadingServicos}
                                page_numb={this.state.page_servicos}
                                _onClickPagina={this.onClickPaginaServicos}
                            />
                        )}
                    </Card.Body>
                </Card>
            </Tab>
        );
    };
  
    // Renderizar aba de usuarios
    renderUsersTab = () => {
        const { prestador_id } = this.state;
        
        return (
            <Tab eventKey="users" title="Usuários">
                <Card className="cardDestaque mt-4">
                    <Card.Body>
                        <Row className="mb-3">
                            <Col className="text-right">
                                <Button 
                                    variant="success" 
                                    size="sm"
                                    onClick={() => this.handleShowModalUsuario()}
                                >
                                    Adicionar Usuário
                                </Button>                                
                            </Col>
                        </Row>
                        <Table responsive className="custom-table mt-3">
                            <thead>
                                <tr>
                                    <th>ID do usuário</th>
                                    <th>Nome</th>
                                    <th>E-mail</th>
                                    <th>Nome de usuário</th>
                                    <th>Status</th>
                                    <th>Último login</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            Carregando...
                                        </td>
                                    </tr>
                                ) : this.state.usuarios.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            Nenhum usuário vinculado
                                        </td>
                                    </tr>
                                ) : (
                                    this.state.usuarios.map(usuario => (
                                        <tr key={usuario.id}>
                                            <td>{usuario.id}</td>
                                            <td>{usuario.first_name} {usuario.last_name}</td>
                                            <td>{usuario.email}</td>
                                            <td>{usuario.username}</td>
                                            <td>
                                                {
                                                usuario.is_active ? 
                                                <span className="badge text-bg-success">Ativo</span>
                                                : 
                                                <span className="badge text-bg-warning">Inativo</span>
                                                }
                                            </td>
                                            <td>
                                                {
                                                usuario.last_login ?
                                                formataDataHoraExibicao(usuario.last_login) :
                                                '---'
                                                }
                                            </td>
                                            <td>
                                                {
                                                hasPerm('change_user') &&
                                                <Button 
                                                    variant="secondary" 
                                                    size="sm"
                                                    onClick={() => this.handleShowModalUsuario(usuario)}
                                                >
                                                    Editar
                                                </Button>
                                                }                                                                               
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Tab>
        );
    };

    // Modal de Serviço
    renderModalServico = () => {
        const { showModalServico, servicoAtual, tipo_empresa } = this.state;
        
        return (
            <Modal show={showModalServico} onHide={this.handleCloseModalServico}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {servicoAtual.id ? 'Editar Serviço' : 'Adicionar Serviço'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={this.handleSubmitServico}>
                        <Form.Group className="mb-3">
                            <Form.Label>Serviço</Form.Label>
                            <AsyncSelect
                                cacheOptions
                                loadOptions={this.carregarServicosDisponiveis}
                                defaultOptions
                                placeholder="Selecione um serviço..."
                                value={servicoAtual.servico_id ? { 
                                    value: servicoAtual.servico_id, 
                                    label: servicoAtual.servico_nome 
                                } : null}
                                onChange={(e) => this.handleChangeServico(e, 'servico_id')}
                                isDisabled={!!servicoAtual.id}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Valor</Form.Label>
                            <NumericFormat
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                allowNegative={false}
                                prefix={'R$ '}
                                value={servicoAtual.valor}
                                onValueChange={(values) => this.handleChangeServico(values, 'valor')}
                                className="form-control"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Valor para parceiros</Form.Label>
                            <NumericFormat
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                allowNegative={false}
                                prefix={'R$ '}
                                value={servicoAtual.valor_parceiros}
                                onValueChange={(values) => this.handleChangeServico(values, 'valor_parceiros')} 
                                className="form-control"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Valor de compra</Form.Label>
                            <NumericFormat
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                allowNegative={false}
                                prefix={'R$ '}
                                value={servicoAtual.valor_compra}
                                onValueChange={(values) => this.handleChangeServico(values, 'valor_compra')}
                                className="form-control"
                            />
                        </Form.Group>

                        <Button variant="success" type="submit">
                            Salvar
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    };

    //modal de usuario
    renderModalUsuario = () => {
        const { showModalUsuario, usuarioAtual } = this.state;
        
        return (
            <Modal show={showModalUsuario} size="lg" onHide={this.handleCloseModalUsuario}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {usuarioAtual.id ? 'Editar usuário' : 'Adicionar usuário'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={this.handleSubmitUsuario}>
                        <Row>
                            <Col sm={12}>
                                <Form.Group className="mb-3">
                                    <Form.Check
                                        type="checkbox"
                                        name="is_active"
                                        id="is_active"
                                        label={
                                            <>
                                            Ativo <span className="text-danger">*</span>
                                            </>
                                        }
                                        checked={!!this.state.usuarioAtual.is_active}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.aceitaTermos}
                                    />
                                    {this.state.usuarioErrors.is_active && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.is_active}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        Nome <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="first_name"
                                        required
                                        placeholder="Nome"
                                        value={this.state.usuarioAtual.first_name || ''}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.first_name}
                                    />
                                    {this.state.usuarioErrors.first_name && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.first_name}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        Sobrenome <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="last_name"
                                        required
                                        placeholder="Sobrenome"
                                        value={this.state.usuarioAtual.last_name || ''}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.last_name}
                                    />
                                        {this.state.usuarioErrors.last_name && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.last_name}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        E-mail <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        required
                                        placeholder="E-mail"
                                        value={this.state.usuarioAtual.email || ''}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.email}
                                    />
                                        {this.state.usuarioErrors.email && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.email}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        Nome de usuário <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="username"
                                        required
                                        placeholder="Nome de usuário"
                                        value={this.state.usuarioAtual.username || ''}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.username}
                                    />
                                        {this.state.usuarioErrors.username && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.username}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Grupo de permissões </Form.Label>
                                    <AsyncSelect
                                        required
                                        cacheOptions
                                        loadOptions={this.carregarGrupos}
                                        defaultOptions
                                        name="grupo_id"
                                        placeholder="Buscar grupo..."
                                        noOptionsMessage={() => "Nenhum grupo encontrado"}
                                        onChange={this.handleChangeUsuariosSelect('grupo_id')}
                                        className={this.state.usuarioErrors.grupo_id ? 'is-invalid' : ''}
                                        value={this.state.usuarioAtual.grupo_id || null} // null em vez de ''
                                    />
                                    {this.state.usuarioErrors.grupo_id && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.grupo_id}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                        </Row>
                        {
                        !usuarioAtual.id &&
                        <Row>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3 position-relative">
                                    <Form.Label>
                                        Senha <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type={this.state.mostrarSenha.password ? "text" : "password"}
                                        name="password"
                                        required
                                        placeholder="Senha"
                                        value={this.state.usuarioAtual.password || ''}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.password}
                                    />
                                    <i
                                        onClick={() => this.toggleSenhaVisibilidade('password')}
                                        className="senha-icon"
                                        style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                    >
                                        {this.state.mostrarSenha.password ? <FaEyeSlash /> : <FaEye />}
                                    </i>
                                    {this.state.usuarioErrors.password && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.password}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3 position-relative">
                                    <Form.Label>
                                        Confirmar Senha <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type={this.state.mostrarSenha.password_confirm ? "text" : "password"}
                                        name="password_confirm"
                                        required
                                        placeholder="Senha"
                                        value={this.state.usuarioAtual.password_confirm || ''}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.password}
                                    />
                                    <i
                                        onClick={() => this.toggleSenhaVisibilidade('password_confirm')}
                                        className="senha-icon"
                                        style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                    >
                                        {this.state.mostrarSenha.password_confirm ? <FaEyeSlash /> : <FaEye />}
                                    </i>
                                </Form.Group>
                            </Col>
                        </Row>
                        }

                        <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                            {this.state.loading ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    };

    handleMaskAccept = (field) => (value, mask) => {
        this.setState({ [field]: value });
    }

    render(){

        let dados_usuario = getCurrentUser();

        console.log("Dados usuário = ", dados_usuario);

        if(!this.state.permite_editar){
            return (
                <div>
                    <Row className="align-items-center">
                        <Col sm={12}>
                            <h5 className="page-title">Vocẽ não tem permissão para acessar essa página</h5>
                        </Col>
                    </Row>
                </div>
            );
        }

        const temAlvaraCadastrado = !!this.state.alvara_cadastrado;
        const exigeAlvaraPorRegra =
            this.state.is_active && // ativo
            this.state.tipo_pessoa === 'juridica' && // pessoa jurídica
            this.state.tipo_prestador !== 'nao_credenciado' && // não-credenciado
            !['medicos', 'multiprofissionais', 'motoristas'].includes(this.state.categoria);

        const obrigarUploadAlvara =
            exigeAlvaraPorRegra &&
            !temAlvaraCadastrado; // só obriga se ainda não há arquivo

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosPrestador" id="tabs-prestador" className="aditus-tabs">
                    <Tab eventKey="dadosPrestador" title="Dados do provedor">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <Row>
                                        <Col sm={12} xs={12}>
                                            <Form.Label>Tipo Pessoa</Form.Label>
                                            <div className="mb-3">
                                            {
                                                Object.keys(this.list_tipos_pessoa).map((key, index) => ( 
                                                <Form.Check inline type="radio" label={this.list_tipos_pessoa[key]} key={key} id={key} name="tipo_pessoa" value={key} onChange={this.onChangeTipoPessoa} checked={ key === this.state.tipo_pessoa ? true : false } />
                                                ))
                                            }                                              
                                            </div>
                                        </Col>                                        
                                        {this.state.tipo_pessoa === 'fisica' ? (
                                        <>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nome <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" name="nome" required placeholder="Nome" value={this.state.nome} onChange={this.handleChange} />    
                                                    <Form.Text id="nomeHelper" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>CPF</Form.Label>
                                                    <Form.Control as={IMaskInput} unmask="typed" mask="000.000.000-00" placeholder="CPF" name="cpf" value={this.state.cpf} onAccept={this.handleMaskAccept('cpf')} />
                                                    <Form.Text id="cpfHelper" className="text-danger">{this.state.cpfHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Label>Gênero <span className="text-danger">*</span></Form.Label>
                                                <div className="mb-3">
                                                {
                                                    Object.keys(this.list_generos).map((key, index) => ( 
                                                    <Form.Check inline type="radio" label={this.list_generos[key]} key={key} id={key} name="genero" value={key} onChange={this.handleChange} checked={ key === this.state.genero ? true : false } />
                                                    ))
                                                }                                              
                                                </div>
                                            </Col>
                                        </>
                                        ) : (
                                        <>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>CNPJ <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control as={IMaskInput} unmask="typed" required mask="00.000.000/0000-00" placeholder="CNPJ" name="cnpj" value={this.state.cnpj} onAccept={this.handleMaskAccept('cnpj')} />
                                                    <Form.Text id="cnpjHelper" className="text-danger">{this.state.cnpjHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>   
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Razão social <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" name="razao_social" required placeholder="Razão Social" value={this.state.razao_social} onChange={this.handleChange} />    
                                                    <Form.Text id="razaoSocialHelper" className="text-danger">{this.state.razaoSocialHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nome fantasia <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" name="nome_fantasia" required placeholder="Nome fantasia" value={this.state.nome_fantasia} onChange={this.handleChange} />
                                                    <Form.Text id="nomeFantasiaHelper" className="text-danger">{this.state.nomeFantasiaHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </>
                                        )}

                                        {/* Tipo Empresa / Faturamento / Agendamentos / Matriz — obrigatórios apenas para PJ */}
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo Empresa {this.state.tipo_pessoa === 'juridica' && (<span className="text-danger">*</span>)}</Form.Label>
                                                <Form.Control as="select" name="tipo_empresa" required={this.state.tipo_pessoa === 'juridica'} value={this.state.tipo_empresa} onChange={this.handleChange}>
                                                    <option value="matriz"selected>Matriz</option>
                                                    <option value="filial">Filial</option>
                                                </Form.Control>
                                                <Form.Text id="tipoEmpresaHelper" className="text-danger">{this.state.tipoEmpresaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        {this.state.tipo_empresa !== 'matriz' && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tipo Faturamento {this.state.tipo_pessoa === 'juridica' && (<span className="text-danger">*</span>)}</Form.Label>
                                                    <Form.Control as="select" name="tipo_faturamento" required={this.state.tipo_pessoa === 'juridica'} value={this.state.tipo_faturamento} onChange={this.handleChange}>
                                                        <option value="">Selecione o Tipo de Faturamento</option>
                                                        {Object.entries(this.list_tipos_faturamento).map(([chave, valor]) => (
                                                            <option key={chave} value={chave}>{valor}</option>
                                                        ))}
                                                    </Form.Control>
                                                    <Form.Text id="tipoFaturamentoHelper" className="text-danger">{this.state.tipoFaturamentoHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        )}
                                        {this.state.tipo_empresa == 'matriz' && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Visualizar Agendamentos das Filiais {this.state.tipo_pessoa === 'juridica' && (<span className="text-danger">*</span>)}</Form.Label>
                                                    <Form.Control as="select" name="visualizar_agendamentos_filiais" required={this.state.tipo_pessoa === 'juridica'} value={this.state.visualizar_agendamentos_filiais} onChange={this.handleChange} disabled={this.state.tipo_empresa !== 'matriz'}>
                                                        <option value="true"selected>Sim</option>
                                                        <option value="false">Não</option>
                                                    </Form.Control>
                                                    <Form.Text id="tipoEmpresaHelper" className="text-danger">{this.state.tipoEmpresaHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        )}
                                        {this.state.tipo_empresa === 'filial' && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Buscar Matriz {this.state.tipo_pessoa === 'juridica' && (<span className="text-danger">*</span>)}</Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions
                                                        loadOptions={this.carregarMatrizes}
                                                        defaultOptions
                                                        name="matriz_id"
                                                        placeholder="Buscar matriz..."
                                                        noOptionsMessage={() => "Nenhuma matriz encontrada"}
                                                        onChange={(e) => this.handleChange(e, 'matriz_id')}
                                                        required={this.state.tipo_pessoa === 'juridica' && this.state.tipo_empresa === 'filial'}
                                                        value={this.state.matriz_id ? { value: this.state.matriz_id, label: this.state.matriz_nome } : null}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {/* EMAIL */}
                                        <Col sm={this.state.mostrarEmail3 ? 6 : 5} xs={12}>
                                            <Form.Group className="mb-3">  
                                                <Form.Label>E-mail {this.state.tipo_pessoa === "juridica" && (<span className="text-danger">*</span>)}</Form.Label>
                                                <Form.Control type="email" name="email" placeholder="Email" value={this.state.email} onChange={this.handleChange} required={this.state.tipo_pessoa === "juridica"} />    
                                                <Form.Text id="emailHelper" className="text-danger">{this.state.emailHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        {!this.state.mostrarEmail3 && this.state.tipo_pessoa === 'juridica' && (
                                            <Col className="d-flex align-items-end">
                                                    <Button variant="outline-primary" onClick={this.mostrarMaisEmail} className="mb-3" style={{ fontSize: '0.75rem', width: '26px', height: '26px', lineHeight: '1', padding: '0', textAlign: 'center', position: 'relative', top: '-10px'}}>
                                                        +
                                                    </Button>
                                            </Col>
                                        )}
                                        {this.state.mostrarEmail2 && this.state.tipo_pessoa === 'juridica' && (
                                            <>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>E-mail 2</Form.Label>
                                                        <Form.Control type="email" name="email_2" placeholder="Email" value={this.state.email_2} onChange={this.handleChange} />    
                                                        <Form.Text id="emailHelper" className="text-danger">{this.state.emailHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col> 
                                            </>
                                        )}
                                        {this.state.mostrarEmail3 && this.state.tipo_pessoa === 'juridica' && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>E-mail 3</Form.Label>
                                                    <Form.Control type="email" name="email_3" placeholder="Email" value={this.state.email_3} onChange={this.handleChange} />    
                                                    <Form.Text id="emailHelper" className="text-danger">{this.state.emailHelper}</Form.Text>
                                                </Form.Group>
                                            </Col> 
                                        )}

                                        {/* TELEFONE */}
                                        <Col sm={this.state.mostrarTelefone3 ? 6 : 5} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Telefone {this.state.tipo_pessoa === "juridica" && (<span className="text-danger">*</span>)}</Form.Label>
                                                <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Telefone do provedor" name="telefone" value={this.state.telefone} onAccept={value => this.setState({ telefone: value })} required={this.state.tipo_pessoa === "juridica"}/>
                                                <Form.Text id="telefoneHelper" className="text-danger">{this.state.telefoneHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        {!this.state.mostrarTelefone3 && this.state.tipo_pessoa === "juridica" && (
                                            <Col className="d-flex align-items-end">

                                                    <Button variant="outline-primary" onClick={this.mostrarMaisTelefone} className="mb-3" style={{ fontSize: '0.75rem', width: '26px', height: '26px', lineHeight: '1', padding: '0', textAlign: 'center', position: 'relative', top: '-10px'}}>
                                                        +
                                                    </Button>
                                            </Col>
                                        )}
                                        {this.state.mostrarTelefone2 && this.state.tipo_pessoa === "juridica" && (
                                            <>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Telefone 2</Form.Label>
                                                        <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Telefone do provedor" name="telefone_2" value={this.state.telefone_2 || ''} onAccept={value => this.setState({ telefone_2: value })} />
                                                        <Form.Text id="telefoneHelper" className="text-danger">{this.state.telefone_2Helper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            </>
                                        )}
                                        {this.state.mostrarTelefone3 && this.state.tipo_pessoa === "juridica" && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Telefone 3</Form.Label>
                                                    <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Telefone do provedor" name="telefone_3" value={this.state.telefone_3 || ''} onAccept={value => this.setState({ telefone_3: value })}/>
                                                    <Form.Text id="telefoneHelper" className="text-danger">{this.state.telefone_3Helper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {/* CELULAR */}
                                        <Col sm={this.state.mostrarCelular3 ? 6 : 5} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Celular {this.state.tipo_pessoa === "juridica" && (<span className="text-danger">*</span>)}</Form.Label>
                                                <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Celular do provedor" name="celular" value={this.state.celular} onAccept={value => this.setState({ celular: value })} required={this.state.tipo_pessoa === "juridica"} />
                                                <Form.Text id="celularHelper" className="text-danger">{this.state.celularHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>   
                                        {!this.state.mostrarCelular3 && this.state.tipo_pessoa === "juridica" && (
                                            <Col className="d-flex align-items-end">
                                                    <Button variant="outline-primary" onClick={this.mostrarMaisCelular} className="mb-3" style={{ fontSize: '0.75rem', width: '26px', height: '26px', lineHeight: '1', padding: '0', textAlign: 'center', position: 'relative', top: '-10px'}}>
                                                        +
                                                    </Button>
                                            </Col>
                                        )}
                                        {this.state.mostrarCelular2 && this.state.tipo_pessoa === "juridica" && (
                                            <>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Celular 2</Form.Label>
                                                        <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Celular do provedor" name="celular_2" value={this.state.celular_2} onAccept={value => this.setState({ celular_2: value })} />
                                                        <Form.Text id="celularHelper" className="text-danger">{this.state.celularHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>  
                                            </>
                                        )}
                                        {this.state.mostrarCelular3 && this.state.tipo_pessoa === "juridica" && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Celular 3</Form.Label>
                                                    <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Celular do provedor" name="celular_3" value={this.state.celular_3} onAccept={value => this.setState({ celular_3: value })} />
                                                    <Form.Text id="celularHelper" className="text-danger">{this.state.celularHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>    
                                        )}
                                        
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Categoria</Form.Label>
                                                <Form.Control as="select" name="categoria" required value={this.state.categoria} onChange={this.handleChange}>
                                                    <option value="">Selecione a Categoria</option>
                                                    {Object.entries(this.list_categorias).map(([chave, valor]) => (
                                                        <option key={chave} value={chave}>{valor}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text id="categoriaHelper" className="text-danger">{this.state.categoriaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        {/*(this.state.categoria == 'medicos')  && ( 
                                        <Col sm={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Especialidade</Form.Label>
                                                <AsyncSelect
                                                    isMulti
                                                    cacheOptions
                                                    loadOptions={this.carregarEspecialidades}
                                                    defaultOptions
                                                    name="especialidade_id"
                                                    placeholder="Buscar especialidade..."
                                                    noOptionsMessage={() => "Nenhuma especialidade encontrada"}
                                                    onChange={(selectedOption) => this.handleEspecialidadesChange(selectedOption)} 
                                                    value={this.state.especialidades}
                                                />
                                            </Form.Group>
                                        </Col>
                                        )*/}
                                        {/*(this.state.categoria == 'multiprofissionais')  && ( 
                                        <Col sm={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Categoria de Multiprofissional</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarCategoriaMultiprofissional}
                                                    defaultOptions
                                                    name="categoria_multiprofissional_id"
                                                    placeholder="Buscar categoria..."
                                                    noOptionsMessage={() => "Nenhuma categoria multiprofissional encontrada"}
                                                    onChange={e => this.handleChange(e, 'categoria_multiprofissional_id')}
                                                    value={this.state.categoria_multiprofissional_id ? { value: this.state.categoria_multiprofissional_id, label: this.state.categoria_multiprofissional_nome } : null}
                                                />
                                            </Form.Group>
                                        </Col>
                                        )}
                                        {this.state.categoria_multiprofissional_id  && ( 
                                        <Col sm={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Multíplas Especialidades</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarEspecialidadeMultiprofissional}
                                                    defaultOptions
                                                    name="especialidade_multiprofissional_id"
                                                    placeholder="Buscar especialidade ..."
                                                    noOptionsMessage={() => "Nenhuma especialidade multiprofissional encontrada"}
                                                    onChange={e => this.handleChange(e, 'especialidade_multiprofissional_id')}
                                                    value={this.state.especialidade_multiprofissional_id ? { value: this.state.especialidade_multiprofissional_id, label: this.state.especialidade_multiprofissional_nome } : null}
                                                />
                                            </Form.Group>
                                        </Col>
                                        )*/}
                                        {(this.state.categoria == 'medicos' || this.state.categoria == 'multiprofissionais') && ( 
                                        <>
                                            {dados_usuario['tipo_usuario'] == '' && (
                                            <Row>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>É Mentor?</Form.Label>
                                                        <div>
                                                            <Button 
                                                                variant={this.state.mentor ? "success" : "outline-secondary"}
                                                                onClick={() => this.setState({ mentor: true })}>
                                                                Sim
                                                            </Button>
                                                            {' '}
                                                            <Button 
                                                                variant={!this.state.mentor ? "danger" : "outline-secondary"}
                                                                onClick={() => this.setState({ mentor: false })}>
                                                                Não
                                                            </Button>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            )}
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Registro <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" name="registro" required placeholder="Registro" value={this.state.registro} onChange={this.handleChange} />    
                                                    <Form.Text id="registroHelper" className="text-danger">{this.state.registroHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Registro UF <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control as="select" name="registro_uf" value={this.state.registro_uf} required onChange={this.handleChange}>
                                                        <option value="">Selecione o Estado</option>
                                                        {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                            <option key={sigla} value={sigla}>{nome}</option>
                                                        ))}
                                                    </Form.Control>
                                                    <Form.Text id="registroUfHelper" className="text-danger">{this.state.registroUfHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </>
                                        )}
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome do contato</Form.Label>
                                                <Form.Control type="text" name="contato_nome" placeholder="Nome do contato" value={this.state.contato_nome} onChange={this.handleChange} />    
                                                <Form.Text id="contatoNomeHelper" className="text-danger">{this.state.contatoNomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Email do contato <span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="mail" name="contato_email" placeholder="Email do contato" value={this.state.contato_email} onChange={this.handleChange} />    
                                                <Form.Text id="contatoEmailHelper" className="text-danger">{this.state.contatoEmailHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Celular do contato</Form.Label>
                                                <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Celular do contato" name="contato_celular" value={this.state.contato_celular} onChange={this.handleChange} />
                                                <Form.Text id="contatoCelularHelper" className="text-danger">{this.state.contatoCelularHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {(this.state.categoria == 'laboratorio_diagnostico')  && ( 
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Logomarca para Termo PDF {this.logomarcaTermo()}
                                                </Form.Label>
                                                <Form.Control type="file" name="imagem_upload" onChange={this.onChangeImagem} ref={this.fileInput} />
                                                <Form.Text id="formImagemHelpBlock" className="text-danger">{this.state.imagemHelper}</Form.Text>
                                                {this.state.logomarca_pdf_termo && (
                                                    <div>
                                                        <img src={this.state.logomarca_pdf_termo} alt="Logomarca Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    )}
                                    
                                    <h4 className="mt-3">Endereço</h4>
                                    <Row>                                        
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>CEP</Form.Label>
                                                <Form.Control as={IMaskInput} mask="00000-000" type="text" placeholder="CEP" value={this.state.cep} onAccept={(value) => this.onChangeCep(value)} />
                                                <Form.Text id="cepHelper" className="text-danger">{this.state.cepHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>UF</Form.Label>
                                                    <Form.Control as="select" name="uf" value={this.state.uf} onChange={this.handleChange}>
                                                    <option value="">Selecione o Estado</option>
                                                    {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text id="ufHelper" className="text-danger">{this.state.ufHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Estados de Atendimento</Form.Label>
                                                <Select
                                                    isMulti
                                                    options={Object.entries(estados).map(([sigla, nome]) => ({ value: sigla, label: nome }))}
                                                    value={this.state.estados_atendimento}
                                                    onChange={(selected) => this.setState({ estados_atendimento: selected })}
                                                    placeholder="Selecione os estados..."
                                                    classNamePrefix="select"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cidade</Form.Label>
                                                <Form.Control type="text" name="cidade" placeholder="Cidade" value={this.state.cidade} onChange={this.handleChange} />    
                                                <Form.Text id="cidadeHelper" className="text-danger">{this.state.cidadeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Bairro</Form.Label>
                                                <Form.Control type="text" name="bairro" placeholder="Bairro" value={this.state.bairro} onChange={this.handleChange} />    
                                                <Form.Text id="bairroHelper" className="text-danger">{this.state.bairroHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Endereço</Form.Label>
                                                <Form.Control type="text" name="endereco" placeholder="Endereço" value={this.state.endereco} onChange={this.handleChange} />    
                                                <Form.Text id="enderecoHelper" className="text-danger">{this.state.enderecoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Número</Form.Label>
                                                <Form.Control type="text" name="numero" placeholder="Número" value={this.state.numero} onChange={this.handleChange} />    
                                                <Form.Text id="numeroHelper" className="text-danger">{this.state.numeroHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Complemento</Form.Label>
                                                <Form.Control type="text" name="complemento" placeholder="Complemento" value={this.state.complemento} onChange={this.handleChange} />    
                                                <Form.Text id="complementoHelper" className="text-danger">{this.state.complementoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        {dados_usuario['tipo_usuario'] === '' && (
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cadastro Teste</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.cadastro_teste ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ cadastro_teste: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.cadastro_teste ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ cadastro_teste: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        )}
                                        {dados_usuario['tipo_usuario'] === '' && (
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Provedor Credenciado</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.tipo_prestador === 'credenciado' ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ tipo_prestador: 'credenciado' })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={this.state.tipo_prestador === 'nao_credenciado' ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ tipo_prestador: 'nao_credenciado' })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        )}
                                        {(dados_usuario['tipo_usuario'] === '' || hasPerm('add_prestadores')) && (
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cadastro Ativo</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.is_active ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ is_active: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.is_active ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ is_active: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        )}
                                    </Row>
                                        
                                    {(this.state.tipo_pessoa === 'juridica')  ? (
                                        <>
                                            <h4 className="mt-3">Documentos</h4> 
                                            <Row>
                                                <Col sm={12} xs={12}>
                                                    <Row>
                                                        <Col sm={6} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Tipo de Alvará {(exigeAlvaraPorRegra) && (<span className="text-danger">*</span>)}</Form.Label>
                                                                <Form.Control as="select" required={exigeAlvaraPorRegra} name="tipo_alvara" value={this.state.tipo_alvara} onChange={this.handleChange}>
                                                                    <option value="">Selecione o Tipo</option>
                                                                    <option value="alvara">Alvará</option>
                                                                    <option value="alvara_indeterminado">Alvará Indeterminado</option>
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                {this.state.tipo_alvara && (
                                                    <>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Alvará {(exigeAlvaraPorRegra) && (<span className="text-danger">*</span>)}</Form.Label>
                                                            <Form.Control type="file" required={obrigarUploadAlvara} name="alvara" onChange={this.onChangeArquivo} ref={this.fileInput} />
                                                            <p className="mb-0"><i>Extensões permitidas: .jpg, .jpeg, .png e .pdf</i></p>
                                                            {this.state.alvara && isValidUrl(this.state.alvara) && (
                                                                <Button variant="light" className="btn-sm" href={this.state.alvara} target="_blank" style={{ marginTop: '10px' }}>
                                                                    <FaEye /> Ver Alvará
                                                                </Button>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Data de Vencimento {(this.state.tipo_alvara === 'alvara' && exigeAlvaraPorRegra) && (<span className="text-danger">*</span>)}</Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="data_vencimento_alvara"
                                                                value={this.state.data_vencimento_alvara}
                                                                onChange={this.handleChange}
                                                                min={new Date().toISOString().split('T')[0]}
                                                                required={(this.state.tipo_alvara === 'alvara' && exigeAlvaraPorRegra)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    </>
                                                )}
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Contrato Social</Form.Label>
                                                        <Form.Control type="file" name="contrato_social" onChange={this.onChangeArquivo} ref={this.fileInputContrato} />
                                                        <p className="mb-0"><i>Extensões permitidas: .jpg, .jpeg, .png e .pdf</i></p>
                                                        {this.state.contrato_social && isValidUrl(this.state.contrato_social) && (
                                                            <Button variant="light" className="btn-sm" href={this.state.contrato_social} target="_blank" style={{ marginTop: '10px' }}>
                                                                <FaEye /> Ver Contrato Social
                                                            </Button>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Status do Contrato</Form.Label>
                                                        <Form.Control as="select" name="status_contrato" value={this.state.status_contrato} onChange={this.handleChange}>
                                                            <option value="">Selecione o Status</option>
                                                            <option value="assinado">Assinado</option>
                                                            <option value="aguardando_assinatura">Aguardando Assinatura</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Certidão de Regularidade</Form.Label>
                                                        <Form.Control type="file" name="certidao_regularidade" onChange={this.onChangeArquivo} ref={this.fileInputCertidao}/>
                                                        <p className="mb-0"><i>Extensões permitidas: .jpg, .jpeg, .png e .pdf</i></p>
                                                        {this.state.certidao_regularidade && isValidUrl(this.state.certidao_regularidade) && (
                                                            <Button variant="light" className="btn-sm" href={this.state.certidao_regularidade} target="_blank" style={{ marginTop: '10px' }}>
                                                                <FaEye /> Ver Certidão de Regularidade
                                                            </Button>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Cartão CNPJ</Form.Label>
                                                        <Form.Control type="file" name="cartao_cnpj" onChange={this.onChangeArquivo} ref={this.fileInputCNPJ}/>
                                                        <p className="mb-0"><i>Extensões permitidas: .jpg, .jpeg, .png e .pdf</i></p>
                                                        {this.state.cartao_cnpj && isValidUrl(this.state.cartao_cnpj) && (
                                                            <Button variant="light" className="btn-sm" href={this.state.cartao_cnpj} target="_blank" style={{ marginTop: '10px' }}>
                                                                <FaEye /> Ver Cartão CNPJ
                                                            </Button>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Treinamento</Form.Label>
                                                        <Form.Control as="select" name="treinamento" value={this.state.treinamento} onChange={this.handleChange}>
                                                            <option value="">Selecione a Categoria</option>
                                                            <option value="treinamento_aplicado">Treinamento Aplicado</option>
                                                            <option value="treinamento_agendado">Aguardando Agendamento</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </>
                                    ) : null}

                                    <Modal show={this.state.showModalConfirmacao} onHide={this.handleCancelarUpload} centered size="xl">
                                        <Modal.Header closeButton>
                                            <Modal.Title>Deseja fazer a inclusão deste documento?</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body className="text-center">
                                            {this.state.uploadFile && (
                                                this.state.uploadFile.type.startsWith("image/") ? (
                                                    <img src={this.state.uploadPreview} alt="Prévia" style={{ maxWidth: '100%' }} />
                                                ) : (
                                                    <div ref={this.pdfWrapperRef} className="pdfPreview">
                                                        <Document
                                                            file={this.state.uploadPreview}
                                                            onLoadSuccess={this.onDocumentLoadSuccess}
                                                            >
                                                                {Array.from({ length: this.state.numPages }, (_, i) => (
                                                                    <Page 
                                                                        key={i} 
                                                                        renderTextLayer={false}
                                                                        renderAnnotationLayer={false}
                                                                        pageNumber={i + 1} 
                                                                        width={this.state.pageWidth}
                                                                        />
                                                                ))}
                                                        </Document>
                                                    </div>
                                                )
                                            )}
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="danger" size="sm" onClick={this.handleCancelarUpload}>
                                                Cancelar
                                            </Button>
                                            <Button variant="success" size="sm" onClick={this.handleConfirmarUpload}>
                                                Confirmar
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>

                                    {(this.state.categoria == 'medicos' || this.state.categoria == 'multiprofissionais') && ( 
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Acesso exclusivo de programa?</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.acesso_unico ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ acesso_unico: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.acesso_unico ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ acesso_unico: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    )}

                                    {hasPerm('add_programas_prestadores') && this.state.acesso_unico && (
                                        <>
                                            <h4 className="mt-3">Programa</h4>
                                            <Row>
                                                <Col sm={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Cliente</Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions
                                                            loadOptions={this.carregarClientesPrograma}
                                                            defaultOptions
                                                            name="cliente_id"
                                                            placeholder="Buscar cliente..."
                                                            noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                            onChange={e => this.handleChange(e, 'cliente_id')}
                                                            value={this.state.cliente_id ? { value: this.state.cliente_id, label: this.state.cliente_nome } : null}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                {this.state.cliente_id && (
                                                    <>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Programa</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={(inputValue) => this.carregarProgramasCliente(inputValue, this.state.cliente_id)}
                                                                    defaultOptions
                                                                    name="programa_uuid"
                                                                    placeholder="Buscar programa..."
                                                                    noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                    onChange={e => this.handleChange(e, 'programa_uuid')}
                                                                    value={this.state.programa_uuid ? { value: this.state.programa_uuid, label: this.state.programa_nome } : null}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-1">
                                                                <Form.Label>Termo</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={this.carregarTermos}
                                                                    defaultOptions
                                                                    name="termo_prestador_id"
                                                                    placeholder="Buscar termo..."
                                                                    noOptionsMessage={() => "Nenhum termo encontrado"}
                                                                    onChange={e => this.handleChange(e, 'termo_prestador_id')}
                                                                    value={this.state.termo_prestador_id ? { value: this.state.termo_prestador_id, label: this.state.termo_prestador_nome } : null}
                                                                />
                                                            </Form.Group>
                                                            <Form.Check
                                                                className="mb-3" 
                                                                type="checkbox"
                                                                name="assinatura_letssign"
                                                                id="assinatura_letssign"
                                                                label="Assinatura LetsSign"
                                                                checked={this.state.assinatura_letssign ? true : false}
                                                                onChange={e => this.handleChange(e, 'assinatura_letssign')}
                                                            />
                                                        </Col>
                                                        <Col sm={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Alerta do atendimento</Form.Label>
                                                                <Form.Control 
                                                                    as="textarea" 
                                                                    name="alerta_atendimento"
                                                                    value={this.state.alerta_atendimento} 
                                                                    onChange={this.handleChange}
                                                                    className="custom-textarea3"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </>
                                                )}
                                            </Row>
                                        </>
                                    )}   

                                    {this.state.is_active && !this.state.prestador_id && (dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'administrador' || dados_usuario['tipo_usuario'] === 'gestor') && (
                                        <>
                                            <h4 className="mt-3">Dados de Acesso</h4>
                                            <Alert className="info">Se desejar criar um usuário para este provedor selecione <strong>obrigatoriamente</strong> um <strong>Grupo de Usuário</strong> e preencha os campos <strong>Senha</strong> e <strong>Confirmar Senha</strong></Alert>
                                            <Row>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Grupo de Usuário </Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions
                                                            loadOptions={this.carregarGrupos}
                                                            defaultOptions
                                                            name="grupo_id"
                                                            placeholder="Buscar grupo..."
                                                            noOptionsMessage={() => "Nenhum grupo encontrado"}
                                                            onChange={this.onChangeGrupo}
                                                            value={this.state.grupo_id ? { value: this.state.grupo_id, label: this.state.grupo_nome } : null}
                                                        />
                                                        <Form.Text className="text-danger">{this.state.grupoIdHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>                                        
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3 position-relative">
                                                        <Form.Label>Senha <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control
                                                            type={this.state.mostrarSenha.senha ? "text" : "password"}
                                                            name="senha"
                                                            placeholder="Senha"
                                                            value={this.state.senha}
                                                            onChange={this.handleChange}
                                                        />
                                                        <i
                                                            onClick={() => this.toggleSenhaVisibilidade('senha')}
                                                            className="senha-icon"
                                                            style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                                        >
                                                            {this.state.mostrarSenha.senha ? <FaEyeSlash /> : <FaEye />}
                                                        </i>
                                                    </Form.Group>
                                                    <p className="mb-0">Requisitos da senha: </p>
                                                    <ul>
                                                        <li style={{ color: this.state.requisitosSenha.tamanho ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.tamanho ? '700' : '400' }}>
                                                            Quantidade de caracteres maior que 8 {this.state.requisitosSenha.tamanho && <FaCheck />}
                                                        </li>
                                                        <li style={{ color: this.state.requisitosSenha.minuscula ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.minuscula ? '700' : '400' }}>
                                                            Uma letra minuscula {this.state.requisitosSenha.minuscula && <FaCheck />}
                                                        </li>
                                                        <li style={{ color: this.state.requisitosSenha.maiuscula ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.maiuscula ? '700' : '400' }}>
                                                            Uma letra maiuscula {this.state.requisitosSenha.maiuscula && <FaCheck />}
                                                        </li>
                                                        <li style={{ color: this.state.requisitosSenha.numero ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.numero ? '700' : '400' }}>
                                                            Um número de 0 a 9 {this.state.requisitosSenha.numero && <FaCheck />}
                                                        </li>
                                                        <li style={{ color: this.state.requisitosSenha.especial ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.especial ? '700' : '400' }}>
                                                            Pelo menos um dos seguintes caracteres $@#&! {this.state.requisitosSenha.especial && <FaCheck />}
                                                        </li>
                                                    </ul>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3 position-relative">
                                                        <Form.Label>Confirmar Senha <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control
                                                            type={this.state.mostrarSenha.senhaConfirma ? "text" : "password"}
                                                            name="senha_confirma"
                                                            placeholder="Confirmar Senha"
                                                            value={this.state.senha_confirma}
                                                            onChange={this.handleChange}
                                                        />
                                                        <i
                                                            onClick={() => this.toggleSenhaVisibilidade('senhaConfirma')}
                                                            className="senha-icon"
                                                            style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                                        >
                                                            {this.state.mostrarSenha.senhaConfirma ? <FaEyeSlash /> : <FaEye />}
                                                        </i>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab> 

                    {this.state.prestador_id &&  hasPerm('add_programas_prestadores') && (
                        <Tab eventKey="programasPrestador" title="Programas">
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaProgramasPrestador}>
                                        <h4>Programas do Provedor</h4>
                                        {this.state.programas.map((programa, index) => {

                                            /*if(dados_usuario['ambiente_programa_id'] && programa.programa_id) {
                                                if(dados_usuario['ambiente_programa_id'] !== programa.programa_id) {
                                                    return;
                                                }
                                            }*/

                                            return (
                                                <div key={index} className="row-list">
                                                    <Row>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Cliente</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={this.carregarClientesPrograma}
                                                                    defaultOptions
                                                                    name="cliente_id"
                                                                    placeholder="Buscar cliente..."
                                                                    noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                                    onChange={e => this.handleProgramaChange(index, e, 'cliente_id')}
                                                                    value={programa.cliente_id ? { value: programa.cliente_id, label: programa.cliente_nome } : null}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {programa.cliente_id && (
                                                            <>
                                                                <Col sm={4}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Programa</Form.Label>
                                                                        <AsyncSelect
                                                                            key={programa.keyPrograma}  // Usa a chave dinâmica para forçar re-renderização
                                                                            cacheOptions
                                                                            loadOptions={(inputValue) => this.carregarProgramasClienteRepetidor(inputValue, programa.cliente_id)}
                                                                            defaultOptions
                                                                            name="programa_id"
                                                                            placeholder="Buscar programa..."
                                                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                            onChange={e => this.handleProgramaChange(index, e, 'programa_id')}
                                                                            value={programa.programa_id ? { value: programa.programa_id, label: programa.programa_nome } : null}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col sm={4}>
                                                                    <Form.Group className="mb-1">
                                                                        <Form.Label>Termo</Form.Label>
                                                                        <AsyncSelect
                                                                            key={programa.keyPrograma + 999}  // Usa a chave dinâmica para forçar re-renderização
                                                                            cacheOptions
                                                                            loadOptions={this.carregarTermos}
                                                                            defaultOptions
                                                                            name="termo_prestador_id"
                                                                            placeholder="Buscar termo..."
                                                                            noOptionsMessage={() => "Nenhum termo encontrado"}
                                                                            onChange={e => this.handleProgramaChange(index, e, 'termo_prestador_id')}
                                                                            value={programa.termo_prestador_id ? { value: programa.termo_prestador_id, label: programa.termo_prestador_nome } : null}
                                                                        />
                                                                    </Form.Group>
                                                                    <Form.Check
                                                                        className="mb-3" 
                                                                        type="checkbox"
                                                                        name="assinatura_letssign"
                                                                        id={'assinatura_letssign_' + index}
                                                                        label="Assinatura LetsSign"
                                                                        checked={programa.assinatura_letssign ? true : false}
                                                                        onChange={e => this.handleProgramaChange(index, e, 'assinatura_letssign')}
                                                                    />
                                                                </Col>
                                                                <Col sm={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Alerta do atendimento</Form.Label>
                                                                        <Form.Control 
                                                                            as="textarea" 
                                                                            name="alerta_atendimento"
                                                                            value={programa.alerta_atendimento} 
                                                                            onChange={e => this.handleProgramaChange(index, e, 'alerta_atendimento')}
                                                                            className="custom-textarea3"
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col sm={12} xs={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Laboratório com exclusividade</Form.Label>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            name="exclusivo_vinculados"
                                                                            id={'exclusivo_vinculados_' + index}
                                                                            label="Médicos vinculados ao laboratório só podem solicitar atendimento para o laboratório"
                                                                            checked={programa.exclusivo_vinculados ? true : false}
                                                                            onChange={e => this.handleProgramaChange(index, e, 'exclusivo_vinculados')}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </>
                                                        )}
                                                    </Row>
                                                    <Button variant="success" className="btn-sm" onClick={() => this.salvarPrograma(index)}><FaCheck className="me-1" /> Salvar Programa</Button>&nbsp;&nbsp;
                                                    <Button variant="danger" className="btn-sm ml-3" onClick={() => this.removerPrograma(index)}><FaTimes className="me-1" /> Remover Programa</Button>
                                                </div>
                                            )
                                        })}
                                        <Button variant="secondary" onClick={this.adicionarPrograma}><FaStream /> Adicionar Programa</Button>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                        </Tab>
                    )}   

                                           
                    {this.state.prestador_id && (this.state.categoria == 'medicos' || this.state.categoria == 'multiprofissionais')  && ( 
                            <Tab eventKey="laboratoriosPrestador" title="Laboratórios">
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Form onSubmit={this.enviaClientesPrestador}>
                                            <h4>Laboratórios do Provedor</h4>
                                            {this.state.laboratorios.map((laboratorio, index) => (
                                                <div key={index} className="row-list">
                                                    <Row>
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Laboratório</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={this.carregarLaboratorios}
                                                                    defaultOptions
                                                                    name="laboratorio_id"
                                                                    placeholder="Buscar laboratório..."
                                                                    noOptionsMessage={() => "Nenhum laboratório encontrado"}
                                                                    onChange={e => this.handleLaboratorioChange(index, e, 'laboratorio_id')}
                                                                    value={laboratorio.laboratorio_id ? { value: laboratorio.laboratorio_id, label: laboratorio.laboratorio_nome } : null}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    {!laboratorio.id && (
                                                        <Button variant="success" className="btn-sm me-2" onClick={() => this.salvarLaboratorio(index)}><FaCheck className="me-1" /> Salvar Laboratório</Button>
                                                    )}
                                                    <Button variant="danger" className="btn-sm" onClick={() => this.removerLaboratorio(index)}><FaTimes className="me-1" /> Remover Laboratório</Button>
                                                </div>
                                            ))}
                                            <Button variant="secondary" onClick={this.adicionarLaboratorio}><FaStream /> Adicionar Laboratório</Button>
                                        </Form> 
                                    </Card.Body>                
                                </Card>
                            </Tab>
                        )}    
                        {this.state.prestador_id &&  hasPerm('add_programas_prestadores') && (
                            this.renderServicosTab()     
                        )}
                        {this.state.prestador_id &&  hasPerm('add_user') && (
                            this.renderUsersTab()     
                        )}
                </Tabs>
                
                {this.renderModalServico()}
                {this.renderModalUsuario()}
            </div>
        )
    }
}

export default withRouter(PrestadoresEdit);
